<template>
  <div>
    <div id="tiny-slider-modal-preview" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="mx-6">
              <div v-html="recomendations" class="center-mode"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Messages-Confirmations:start -->
    <ConfirmMessages :ids="messages" />
    <!-- Messages-Confirmations:end -->

    <!-- Confirmation-Temp-Saved:start -->
    <Message :id="messages.savedTempSuccessId" :text="$t('views.supplements.save_temp')" />
    <!-- Confirmation-Temp-Saved:end -->

    <!-- Suplemento: nombre comercial:start -->
    <div class="intro-y flex items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">
        {{ $t("views.supplements.text10") }}: {{ supplement.langs[lang_key].name }}
      </h2>
    </div>
    <!-- Suplemento: nombre comercial:end -->

    <!-- Loader:start-->
    <div v-if="initialLoading" class="intro-y w-full h-full flex justify-center items-center">
      <div class="wrapper__loading">
        <LoadingIcon icon="tail-spin" />
      </div>
    </div>
    <!-- Loader:end-->

    <!-- Main content:start -->
    <div v-else class="grid grid-cols-1 gap-6 mt-5 mb-12">
      <div class="intro-y col-span-12 lg:col-span-6">
        <!-- Tabs-Languages:start -->
        <div class="lang__tabs nav nav-tabs intro-y flex-col sm:flex-row text-gray-600 rounded-b-none" role="tablist">
          <a
            v-for="(lang, key) in langs"
            :key="key"
            data-toggle="tab"
            @click="changeLang('lang__' + lang.key)"
            :id="'lang__' + lang.key + '-tab'"
            role="tab"
            :data-target="'#lang__' + lang.key"
            href="javascript:;"
            class="tooltip w-full sm:w-40 py-4 text-center flex justify-center items-center rounded-t-md"
            :class="{
              'active border-transparent': activeLang === 'lang__' + lang.key,
              'border border-theme-6 rounded-md': langValidations[lang.key] && activeLang !== 'lang__' + lang.key, // Solo aplica el borde rojo si no es la pestaña activa
            }"
            :aria-controls="'lang__' + lang.key"
            aria-selected="false"
          >
            {{ $t("components.langs." + lang.key + ".name") }}
            <!-- Icono de exclamación para indicar error si lo deseas -->
            <span v-if="langValidations[lang.key]" class="ml-2 text-red-500 font-bold text-lg">!</span>
          </a>
        </div>
        <!-- Tabs-Languages:end -->

        <div v-for="(lang, key) in langs" :key="key" :class="'post__lang__' + lang.key" class="tab-content">
          <div
            :id="'lang__' + lang.key"
            class="tab-pane"
            :class="activeLang === 'lang__' + lang.key ? 'active' : ''"
            role="tabpanel"
            :aria-labelledby="'lang__' + lang.key + '-tab'"
          >
            <!-- BEGIN: Form Layout -->
            <!-- Suplemento: nombre comercial -->
            <div class="intro-y box p-5">
              <!-- Botón Traducir:start -->
              <!-- <div class="flex justify-end mb-4">
                <button
                  type="button"
                  class="btn btn-outline-secondary flex items-center gap-2"
                  :disabled="translating"
                  @click="translateFields"
                >
                  <LoadingIcon v-if="translating" icon="three-dots" class="w-4 h-4 mr-2" />
                  <span v-else class="flex items-center gap-1">
                    <GlobeIcon class="w-4 h-4" />
                    {{ $t("views.supplements.translate_from") || "Traducir desde" }}
                    {{ $t("components.langs." + otherLang.key + ".name") }}
                  </span>
                </button>
              </div> -->
              <!-- Botón Traducir:end -->
              <!-- campo de categoria, con tags -->
              <div class="mt-3">
                <label for="crud-form-3" class="form-label">
                  {{ $t("views.supplements.text12") }}
                </label>

                <!-- wrapper con relative -->
                <div class="input-group input-bg-theme-32 rounded relative">
                  <!-- Placeholder visual -->
                  <span
                    v-if="!supplementCategories || supplementCategories.length === 0"
                    class="absolute left-3 top-2 text-gray-600 text-sm pointer-events-none"
                  >
                    {{ $t("views.supplements.text13") }}
                  </span>

                  <TomSelect
                    ref="category"
                    class="w-full cursor"
                    v-model="supplementCategories"
                    :max="5"
                    :placeholder="$t('views.supplements.text13')"
                    :plugins="['dropdown_input']"
                    :multiple="true"
                  >
                    <option v-for="(category, key) in allCategories" :key="key" :value="category.id">
                      {{ category.name }}
                    </option>
                  </TomSelect>
                </div>

                <div v-if="validations.categories" class="text-theme-6 mt-2">
                  {{ $t("views.supplements.text11") }}
                </div>
              </div>

              <!-- Seccion de nombres-->

              <!-- Nombre comercial -->
              <div class="mt-3">
                <div class="flex flex-col sm:flex-row items-center gap-5">
                  <!-- campo de nombre comercial-->
                  <div class="w-full">
                    <div class="mt-3">
                      <label for="crud-form-1" class="form-label">{{ $t("views.supplements.text51") }} </label>
                      <div class="input-group">
                        <input
                          id="crud-form-1"
                          type="text"
                          name="chart-tooltip"
                          class="form-control w-full"
                          :class="validations.name ? 'border border-theme-6' : ''"
                          :placeholder="$t('views.supplements.text51')"
                          v-model="supplement.langs[lang_key].name"
                          maxlength="255"
                        />
                      </div>
                      <div
                        class="mt-1 text-xs"
                        :class="
                          countChars(supplement.langs[lang_key].name) < 3
                            ? 'text-red-500 font-semibold'
                            : 'text-green-500'
                        "
                      >
                        {{ countChars(supplement.langs[lang_key].name) }}/255
                      </div>

                      <!-- Un solo mensaje -->
                      <div v-if="validations.name" class="text-theme-6 mt-2">
                        {{ $t("views.supplements.text95") }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- campo de nombre quimico-->
              <div class="w-full">
                <!-- Nombre químico -->
                <div class="mt-3">
                  <label for="crud-form-1" class="form-label">{{ $t("views.supplements.text49") }} </label>
                  <div class="input-group">
                    <input
                      id="crud-form-2"
                      type="text"
                      name="chart-tooltip"
                      class="form-control w-full"
                      :class="validations.chemicalName ? 'border border-theme-6' : ''"
                      :placeholder="$t('views.supplements.text49')"
                      v-model="supplement.langs[lang_key].chemicalName"
                      maxlength="255"
                    />
                  </div>
                  <div
                    class="mt-1 text-xs"
                    :class="
                      countChars(supplement.langs[lang_key].chemicalName) < 3
                        ? 'text-red-500 font-semibold'
                        : 'text-green-500'
                    "
                  >
                    {{ countChars(supplement.langs[lang_key].chemicalName) }}/255
                  </div>
                  <div v-if="validations.chemicalName" class="text-theme-6 mt-2">
                    {{ $t("views.supplements.text95") }}
                  </div>
                </div>
              </div>

              <!-- campo de tipo / variedad-->
              <div class="w-full">
                <div class="mt-3">
                  <label for="crud-form-1" class="form-label">{{ $t("views.supplements.text50") }} </label>
                  <div class="input-group">
                    <input
                      id="crud-form-1"
                      type="text"
                      class="form-control w-full"
                      :class="validations.familySupplement ? 'border border-theme-6' : ''"
                      :placeholder="$t('views.supplements.text50')"
                      v-model="supplement.langs[lang_key].familySupplement"
                      maxlength="255"
                    />
                  </div>
                  <div
                    class="mt-1 text-xs"
                    :class="
                      countChars(supplement.langs[lang_key].familySupplement) < 3
                        ? 'text-red-500 font-semibold'
                        : 'text-green-500'
                    "
                  >
                    {{ countChars(supplement.langs[lang_key].familySupplement) }}/255
                  </div>
                  <div v-if="validations.familySupplement" class="text-theme-6 mt-2">
                    {{ $t("views.supplements.text95") }}
                  </div>
                </div>
              </div>

              <!-- campo de descripcion -->
              <div class="mt-3">
                <label for="crud-form-4" class="form-label">
                  {{ $t("views.supplements.text7") }}
                </label>
                <div class="input-group">
                  <textarea
                    id="crud-form-4"
                    type="text"
                    class="form-control"
                    :class="validations.description ? 'border border-theme-6' : ''"
                    :placeholder="$t('views.supplements.text14')"
                    aria-describedby="input-group-1"
                    rows="6"
                    v-model="supplement.langs[lang_key].description"
                    maxlength="255"
                  />
                </div>
                <div
                  class="mt-1 text-xs"
                  :class="
                    countChars(supplement.langs[lang_key].description) < 10
                      ? 'text-red-500 font-semibold'
                      : 'text-green-500'
                  "
                >
                  {{ countChars(supplement.langs[lang_key].description) }}/255
                </div>

                <div v-if="validations.description" class="text-theme-6 mt-2">
                  {{ $t("views.supplements.text95") }}
                </div>
              </div>

              <!-- campo sirve para -->
              <div class="p-4 bg-theme-32 rounded-md mt-6">
                <div class="season">
                  <label for="crud-form-3" class="form-label">
                    {{ $t("views.supplements.text54") }}
                  </label>

                  <div class="input-group input-bg-theme-32 rounded relative">
                    <TomSelect
                      v-model="supplement.usedFor"
                      class="w-full cursor"
                      :placeholder="$t('views.supplements.text30')"
                      :plugins="['dropdown_input']"
                      :multiple="true"
                    >
                      <option v-for="uf in allUsedFor" :key="uf.id" :value="String(uf.id)">
                        {{ uf.name }}
                      </option>
                    </TomSelect>
                    <div
                      class="input-group-text btn border-0 flex items-center justify-center p-2"
                      @click="openPurposeQuickCreateModal"
                      style="cursor: pointer"
                    >
                      <PlusIcon class="w-4 h-4" />
                    </div>
                  </div>
                  <div v-if="validations.usedFor === 'empty'" class="text-theme-6 mt-2">
                    {{ $t("views.supplements.text11") }}
                  </div>
                </div>
              </div>

              <hr class="my-10" />

              <!-- Sección listado de beneficios -->
              <div class="mt-3">
                <label for="crud-form-3" class="form-label font-semibold">
                  {{ $t("views.supplements.text55") }}
                </label>

                <div
                  class="grid gap-6"
                  :class="validations.benefits === 'empty' ? 'border border-red-500 rounded-md p-2' : ''"
                >
                  <div
                    class="border-custom-gray-8 border-1 rounded-lg p-6"
                    v-for="(benefit, key) in supplement.benefits"
                    :key="key"
                  >
                    <div class="input-group gap-5">
                      <!-- Campo beneficio -->
                      <div class="w-1/3">
                        <label for="crud-form-3" class="form-label">
                          {{ $t("views.supplements.text45") }}
                        </label>

                        <div class="input-group input-bg-theme-32 rounded relative">
                          <TomSelect
                            v-model="benefit.id"
                            class="w-full cursor"
                            :placeholder="$t('views.supplements.text78')"
                            :plugins="['dropdown_input']"
                          >
                            <option value="">{{ $t("views.supplements.text30") }}</option>
                            <option v-for="b in allBenefits" :key="b.id" :value="String(b.id)">
                              {{ b.name }}
                            </option>
                          </TomSelect>
                          <div
                            class="input-group-text btn border-0 flex items-center justify-center p-2"
                            @click="openQuickCreateModal(key)"
                            style="cursor: pointer"
                          >
                            <PlusIcon class="w-4 h-4" />
                          </div>
                        </div>
                        <div v-if="validations.benefitId" class="text-theme-6 mt-2">
                          {{ $t("views.supplements.text11") }}
                        </div>
                      </div>

                      <!-- Campo posología -->
                      <div class="w-1/3">
                        <label for="crud-form-3" class="form-label">
                          {{ $t("views.supplements.text57") }}
                        </label>

                        <div class="input-group input-bg-theme-32 rounded relative">
                          <TomSelect
                            ref="posology"
                            class="w-full cursor"
                            v-model="benefit.posology"
                            :placeholder="$t('views.supplements.text30')"
                            :plugins="['dropdown_input']"
                          >
                            <option value="">{{ $t("views.supplements.text30") }}</option>
                            <option
                              v-for="(posology, posologyKey) in allPosologies"
                              :key="posologyKey"
                              :value="posology"
                            >
                              {{ $t("views.posology." + posology) }}
                            </option>
                          </TomSelect>
                        </div>
                        <div v-if="validations.posology" class="text-theme-6 mt-2">
                          {{ $t("views.supplements.text11") }}
                        </div>
                      </div>

                      <!-- Campo problemática -->
                      <div class="w-1/3">
                        <label for="crud-form-3" class="form-label">
                          {{ $t("views.supplements.text86") }}
                        </label>

                        <div class="input-group input-bg-theme-32 rounded relative">
                          <TomSelect
                            v-model="benefit.problemIds"
                            class="w-full cursor"
                            :placeholder="$t('views.supplements.text30')"
                            :plugins="['dropdown_input']"
                            :multiple="true"
                          >
                            <option v-for="p in allProblems" :key="p.id" :value="String(p.id)">
                              {{ p.name }}
                            </option>
                          </TomSelect>
                          <div
                            class="input-group-text btn border-0 flex items-center justify-center p-2"
                            @click="openProblemQuickCreateModal(key)"
                            style="cursor: pointer"
                          >
                            <PlusIcon class="w-4 h-4" />
                          </div>
                        </div>
                        <div v-if="validations.problemIds" class="text-theme-6 mt-2">
                          {{ $t("views.supplements.text11") }}
                        </div>
                      </div>

                      <!-- Botón eliminar -->
                      <div class="w-auto pr-2 flex justify-end items-start">
                        <button
                          v-on:click="removeBenefit(key)"
                          type="button"
                          class="btn-outline-dark p-0 btn-rounded btn-md remove-item"
                        >
                          <XCircleIcon class="btn-source-icon w-6 h-6" />
                        </button>
                      </div>
                    </div>

                    <!-- Campo puntaje total -->
                    <div class="mt-6">
                      <h2 class="form-label font-semibold text-base">
                        {{ $t("views.supplements.text56") }}:
                        {{ benefit.score.totalScore }}
                      </h2>

                      <div class="flex flex-col sm:flex-row items-center gap-5">
                        <!-- Evidencia científica -->
                        <div class="flex flex-col w-full sm:w-1/4 sm:flex-row items-center gap-2">
                          <div class="w-full">
                            <div class="mt-3">
                              <label for="ec-input" class="form-label">
                                {{ $t("views.supplements.text62") }}
                              </label>
                              <div class="input-group">
                                <input
                                  id="ec-input"
                                  type="number"
                                  name="ec"
                                  class="form-control w-full"
                                  :placeholder="$t('views.supplements.text58')"
                                  v-model="benefit.score.ec"
                                  @input="totalScore(benefit)"
                                  min="0"
                                  max="10"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Biodisponibilidad -->
                        <div class="flex flex-col w-full sm:w-1/4 sm:flex-row items-center gap-2">
                          <div class="w-full">
                            <div class="mt-3">
                              <label for="bd-input" class="form-label">
                                {{ $t("views.supplements.text63") }}
                              </label>
                              <div class="input-group">
                                <input
                                  id="bd-input"
                                  type="number"
                                  name="bd"
                                  class="form-control w-full"
                                  :placeholder="$t('views.supplements.text59')"
                                  v-model="benefit.score.bd"
                                  @input="totalScore(benefit)"
                                  min="0"
                                  max="10"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Resultados clínicos -->
                        <div class="flex flex-col w-full sm:w-1/4 sm:flex-row items-center gap-2">
                          <div class="w-full">
                            <div class="mt-3">
                              <label for="rc-input" class="form-label">
                                {{ $t("views.supplements.text64") }}
                              </label>
                              <div class="input-group">
                                <input
                                  id="rc-input"
                                  type="number"
                                  name="rc"
                                  class="form-control w-full"
                                  :placeholder="$t('views.supplements.text60')"
                                  v-model="benefit.score.rc"
                                  @input="totalScore(benefit)"
                                  min="0"
                                  max="10"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Efectos secundarios -->
                        <div class="flex flex-col w-full sm:w-1/4 sm:flex-row items-center gap-2">
                          <div class="w-full">
                            <div class="mt-3">
                              <label for="est-input" class="form-label">
                                {{ $t("views.supplements.text65") }}
                              </label>
                              <div class="input-group">
                                <input
                                  id="est-input"
                                  type="number"
                                  name="est"
                                  class="form-control w-full"
                                  :placeholder="$t('views.supplements.text61')"
                                  v-model="benefit.score.est"
                                  @input="totalScore(benefit)"
                                  min="0"
                                  max="10"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Botón agregar más -->
                    <div class="mt-4">
                      <button @click="addBenefit" type="button" class="btn btn-primary" :disabled="!isFormComplete()">
                        {{ $t("views.supplements.text77") }}
                      </button>
                    </div>
                  </div>
                  <!-- Mensaje cuando no hay ningún beneficio -->
                  <div v-if="validations.benefits === 'empty'" class="text-theme-6 mt-2">
                    {{ $t("views.supplements.text98") }}
                  </div>

                  <!-- Mensaje cuando hay menos de 3 beneficios completos -->
                  <div v-else-if="validations.benefits === 'min'" class="text-theme-6 mt-2">
                    {{ $t("views.supplements.text99") }}
                  </div>
                  <!-- Mensaje cuando hay beneficios duplicados -->
                  <div v-if="validations.benefitsDuplicate" class="text-theme-6 mt-2">
                    {{ $t("views.supplements.validations.duplicate_benefits") || "Tienes 2 beneficios iguales" }}
                  </div>
                </div>
              </div>

              <hr class="my-10" />

              <!-- seccion listado dosis - Listado de dosificación -->
              <div class="mt-3">
                <label for="crud-form-3" class="form-label font-semibold"> {{ $t("views.supplements.text84") }}</label>
                <div class="grid gap-6">
                  <div
                    class="border-custom-gray-8 border-1 rounded-lg p-6"
                    v-for="(dose, doseKey) in supplement.doses"
                    :key="doseKey"
                    :class="validations.doses === 'empty' ? 'border border-red-500 rounded-md p-2' : ''"
                  >
                    <!-- campo sex -->
                    <div class="w-full">
                      <label for="crud-form-3" class="form-label">
                        {{ $t("views.supplements.text66") }}
                      </label>
                      <div class="flex items-center gap-4">
                        <!-- Selector sexo -->
                        <div class="w-full">
                          <TomSelect
                            ref="allBiologicalSex"
                            class="w-full cursor"
                            v-model="dose.biologicalSex"
                            :placeholder="$t('views.supplements.text30')"
                            :input_hide="true"
                          >
                            <option value="null">{{ $t("views.supplements.text30") }}</option>
                            <option v-for="(option, key) in allBiologicalSex" :key="key" :value="option">
                              {{ $t("globals.biological_sex." + option) }}
                            </option>
                          </TomSelect>
                        </div>

                        <!-- Botón eliminar -->
                        <div class="flex justify-end items-center">
                          <button
                            @click="removeDose(doseKey)"
                            type="button"
                            class="btn-outline-dark p-0 btn-rounded btn-md remove-item"
                          >
                            <XCircleIcon class="btn-source-icon w-6 h-6" />
                          </button>
                        </div>
                      </div>

                      <!-- campo edad - rango etario-->
                      <div class="w-full mt-8">
                        <div class="input-group">
                          <AgeRangesSelect
                            v-model="dose.ages"
                            :label="$t('views.supplements.text67')"
                            :error="validations.ages"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="input-group gap-5 mt-4">
                      <div class="w-1/2">
                        <label for="doseModality" class="form-label">{{ $t("views.supplements.text16") }}</label>

                        <TomSelect
                          ref="dose_modality"
                          id="doseModality"
                          class="w-full cursor without_search"
                          v-model="dose.modality"
                          :input_hide="true"
                        >
                          <option value="">{{ $t("views.supplements.text17") }}</option>
                          <option value="SPECIFIC">
                            {{ $t("views.supplements.text18") }}
                          </option>
                          <option value="RANGE">{{ $t("views.supplements.text19") }}</option>
                        </TomSelect>
                        <div v-if="validations.range || validations.value" class="text-theme-6 mt-2">
                          {{ $t("views.supplements.text11") }}
                        </div>
                      </div>

                      <div class="w-1/2">
                        <label for="crud-form-3" class="form-label">{{ $t("views.supplements.text25") }}</label>

                        <TomSelect ref="dose_unit" class="w-full cursor" v-model="dose.unit">
                          <option value="">{{ $t("views.supplements.text26") }}</option>
                          <option value="g">{{ $t("views.units.g") }}</option>
                          <option value="mg">{{ $t("views.units.mg") }}</option>
                          <option value="mcg">{{ $t("views.units.mcg") }}</option>
                          <option value="UI">{{ $t("views.units.UI") }}</option>
                          <option value="gotas">{{ $t("views.units.gotas") }}</option>
                        </TomSelect>
                        <div v-if="validations.range || validations.value" class="text-theme-6 mt-2">
                          {{ $t("views.supplements.text11") }}
                        </div>
                      </div>
                    </div>

                    <!-- campo valores -->
                    <div class="mt-6">
                      <div class="w-full">
                        <!-- campo valor especifico o por rango -->
                        <div
                          class="flex flex-col sm:flex-row items-center gap-2 mt-6"
                          v-if="dose.modality == 'SPECIFIC'"
                        >
                          <!--  campo valor  -->
                          <div class="flex flex-col gap-2 w-full">
                            <div class="flex flex-col sm:flex-row w-full">
                              <label for="crud-form-3">
                                {{ $t("views.supplements.text20") }}
                              </label>

                              <input
                                id="crud-form-3"
                                type="number"
                                min="0"
                                class="form-control form-control-lg w-full text-sm-14"
                                :placeholder="$t('views.supplements.text20')"
                                aria-describedby="input-group-1"
                                v-model="dose.specificValues[0]"
                              />
                            </div>

                            <div v-if="validations.range || validations.value" class="text-theme-6 mt-2">
                              {{ $t("views.supplements.text21") }}
                            </div>
                          </div>

                          <!-- campo valor optimo -->
                          <div class="flex flex-col gap-2 w-full">
                            <div class="flex flex-col sm:flex-row w-full">
                              <label for="crud-form-3">
                                {{ $t("views.supplements.text83") }}
                              </label>

                              <input
                                id="crud-form-3"
                                type="number"
                                min="0"
                                class="form-control form-control-lg w-full text-sm-14"
                                :placeholder="$t('views.supplements.text83')"
                                aria-describedby="input-group-1"
                                v-model="dose.specificValues[1]"
                              />
                            </div>

                            <div v-if="validations.range || validations.value" class="text-theme-6 mt-2">
                              {{ $t("views.supplements.text21") }}
                            </div>
                          </div>

                          <!-- campo Límite superior recomendado -->
                          <div class="flex flex-col gap-2 w-full">
                            <div class="flex flex-col sm:flex-row w-full">
                              <label for="crud-form-3">
                                {{ $t("views.supplements.text68") }}
                              </label>

                              <input
                                id="crud-form-3"
                                type="number"
                                min="0"
                                class="form-control form-control-lg w-full text-sm-14"
                                :placeholder="$t('views.supplements.text68')"
                                aria-describedby="input-group-1"
                                v-model="dose.specificValues[2]"
                              />
                            </div>

                            <div v-if="validations.range || validations.value" class="text-theme-6 mt-2">
                              {{ $t("views.supplements.text21") }}
                            </div>
                          </div>
                        </div>

                        <div class="w-full mt-3" v-else>
                          <!--  campo valor  -->
                          <label for="crud-form-3" class="form-label">
                            {{ $t("views.supplements.text83") }}
                          </label>
                          <div class="input-group w-full">
                            <input
                              id="crud-form-3"
                              type="number"
                              min="0"
                              class="form-control form-control-lg text-sm-14"
                              :placeholder="$t('views.supplements.text23')"
                              aria-describedby="input-group-1"
                              v-model="dose.rangeValues[0].min"
                            />
                            <div class="input-group-text" style="border: solid #293144">
                              {{ $t("views.supplements.text44") }}
                            </div>
                            <input
                              id="crud-form-3"
                              type="number"
                              min="0"
                              class="form-control form-control-lg text-sm-14"
                              :placeholder="$t('views.supplements.text24')"
                              aria-describedby="input-group-1"
                              v-model="dose.rangeValues[0].max"
                            />
                          </div>
                          <div v-if="validations.range || validations.value" class="text-theme-6 mt-2">
                            {{ $t("views.supplements.text21") }}
                          </div>

                          <!-- campo valor optimo -->
                          <label for="crud-form-3" class="form-label mt-3">
                            {{ $t("views.supplements.text20") }}
                          </label>
                          <div class="input-group w-full">
                            <input
                              id="crud-form-3"
                              type="number"
                              min="0"
                              class="form-control form-control-lg text-sm-14"
                              :placeholder="$t('views.supplements.text23')"
                              aria-describedby="input-group-1"
                              v-model="dose.rangeValues[1].min"
                            />
                            <div class="input-group-text" style="border: solid #293144">
                              {{ $t("views.supplements.text44") }}
                            </div>
                            <input
                              id="crud-form-3"
                              type="number"
                              min="0"
                              class="form-control form-control-lg text-sm-14"
                              :placeholder="$t('views.supplements.text24')"
                              aria-describedby="input-group-1"
                              v-model="dose.rangeValues[1].max"
                            />
                          </div>
                          <div v-if="validations.range || validations.value" class="text-theme-6 mt-2">
                            {{ $t("views.supplements.text21") }}
                          </div>

                          <!-- campo Límite superior recomendado -->
                          <label for="crud-form-3" class="form-label mt-3">
                            {{ $t("views.supplements.text68") }}
                          </label>
                          <div class="input-group w-full">
                            <input
                              id="crud-form-3"
                              type="number"
                              min="0"
                              class="form-control form-control-lg text-sm-14"
                              :placeholder="$t('views.supplements.text23')"
                              aria-describedby="input-group-1"
                              v-model="dose.rangeValues[2].min"
                            />
                            <div class="input-group-text" style="border: solid #293144">
                              {{ $t("views.supplements.text44") }}
                            </div>
                            <input
                              id="crud-form-3"
                              type="number"
                              min="0"
                              class="form-control form-control-lg text-sm-14"
                              :placeholder="$t('views.supplements.text24')"
                              aria-describedby="input-group-1"
                              v-model="dose.rangeValues[2].max"
                            />
                          </div>
                          <div v-if="validations.range || validations.value" class="text-theme-6 mt-2">
                            {{ $t("views.supplements.text21") }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Botón para agregar más -->
                    <div class="mt-4">
                      <button @click="addDose" type="button" class="btn btn-primary" :disabled="!validateFields()">
                        {{ $t("views.supplements.text85") }}
                      </button>
                    </div>
                  </div>
                </div>
                <div v-if="validations.doses === 'empty'" class="text-theme-6 mt-2">
                  {{ $t("views.supplements.dose_complete") }}

                  <br v-if="missingSex" />
                  <span v-if="missingSex">
                    {{ $t("views.supplements.missing_sex") }}
                    <strong>{{ missingSex }}</strong>
                  </span>
                </div>
              </div>

              <hr class="my-10" />
              <!-- Campo Generico de Entrada efectos secundarios, sintomas por exceso y deficiencia, actividad sinérgica -->
              <div class="mt-3" v-for="(field, fieldKey) in allFields" :key="fieldKey">
                <label for="crud-form-3" class="form-label">{{ $t(field.label) }}</label>
                <div class="input-group w-full">
                  <input
                    id="crud-form-1"
                    type="text"
                    name="chart-tooltip"
                    class="form-control"
                    :placeholder="$t(field.label)"
                    aria-describedby="input-group-price"
                    v-model="supplement[field.input]"
                    @keyup="addField(field.type, field.input, $event)"
                  />
                  <div id="input-group-price" class="input-group-text btn" @click="addField(field.type, field.input)">
                    <PlusIcon />
                  </div>
                </div>

                <div v-if="validations[field.type]" class="text-theme-6 mt-5">
                  {{ $t("views.supplements.text95") }}
                </div>
                <div class="mt-4" v-if="supplement[field.type].length > 0">
                  <div class="flex flex-col" v-for="(val, key) in supplement[field.type]" :key="key">
                    <!-- Vista normal (no editable) -->
                    <div class="items-center w-full relative" v-if="!(val.langs[lang_key] && val.langs[lang_key].edit)">
                      <div class="intro-x">
                        <div
                          class="px-3 py-2 flex items-center justify-between border-b border-gray-300"
                          :class="val.langs[lang_key]?.validation.active ? 'border-theme-6' : ''"
                        >
                          <!-- Texto -->
                          <div class="flex-1">
                            <div
                              class="font-medium text-sm leading-snug"
                              :class="{ 'opacity-50': !val.langs[lang_key]?.text }"
                            >
                              {{ val.langs[lang_key]?.text || getPlaceholderText(val) }}
                            </div>
                          </div>

                          <!-- Botones -->
                          <div class="flex items-center gap-2 ml-3">
                            <button
                              @click="editField(field.type, val.langs[lang_key], true)"
                              type="button"
                              class="btn-outline-dark btn-rounded btn-xs flex items-center justify-center"
                            >
                              <EditIcon class="btn-source-icon w-4 h-4" />
                            </button>
                            <button
                              @click="deleteField(field.type, key)"
                              type="button"
                              class="btn-outline-dark btn-rounded btn-xs flex items-center justify-center"
                            >
                              <Trash2Icon class="btn-source-icon w-4 h-4" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Vista editable -->
                    <div class="block w-full" v-else>
                      <div class="input-group w-full mb-1">
                        <input
                          id="crud-form-1"
                          type="text"
                          name="effect-secondary"
                          class="form-control"
                          :class="val.langs[lang_key]?.validation.active ? 'border border-theme-6' : ''"
                          :placeholder="getPlaceholderText(val) || $t('views.supplements.text42')"
                          aria-describedby="input-group-price"
                          v-model="val.langs[lang_key].text"
                        />
                        <div
                          id="input-group-price"
                          class="input-group-text btn"
                          @click="editField(field.type, val.langs[lang_key], false)"
                        >
                          <SaveIcon />
                        </div>
                      </div>
                    </div>

                    <!-- Validation for item -->
                    <div class="mb-1 mt-1" v-for="l in langs" :key="l.key">
                      <div v-if="val.langs[l.key]?.validation.active" class="text-theme-6 text-xs px-2">
                        {{ val.langs[l.key]?.validation.text }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- campo de interacciones -->
              <div class="mt-8">
                <label for="crud-form-3" class="form-label font-semibold text-base">
                  {{ $t("views.supplements.text87") }}
                </label>

                <!-- Interactions of supplements:start -->
                <fieldset>
                  <div class="input-group rounded relative">
                    <TomSelect
                      class="w-full cursor"
                      v-model="supplement.interactions.supplement"
                      :placeholder="$t('views.supplements.text10')"
                      v-on:change="addInteraction('supplements', 'supplement')"
                    >
                      <option value="0">
                        {{ $t("views.supplements.text10") }}
                      </option>

                      <option
                        v-for="s in supplement.interactions.supplements"
                        :key="s.supplement_id"
                        :disabled="s.active"
                        :value="s.supplement_id"
                      >
                        {{ s.name }}
                      </option>
                    </TomSelect>
                    <div
                      class="input-group-text btn border-0 flex items-center justify-center p-2 ml-1"
                      @click="openSupplementQuickCreateModal"
                      style="cursor: pointer"
                    >
                      <PlusIcon class="w-4 h-4" />
                    </div>
                  </div>

                  <template
                    v-for="s in supplement.interactions.supplements.filter((s) => s.active)"
                    :key="s.supplement_id"
                  >
                    <div class="intro-x border-custom-gray-8 border-1 rounded-lg px-6 pb-6 my-3">
                      <div class="w-full flex justify-between">
                        <label
                          :for="`supplement-description-${s.supplement_id}`"
                          class="py-3 cursor-pointer flex items-center gap-1"
                          title="Ver suplemento"
                          @click="goToSupplement(s.supplement_id)"
                        >
                          {{ s.name }}
                          <LinkIcon class="btn-source-icon" />
                        </label>

                        <button
                          v-on:click="removeInteraction(s, 'supplements', 'supplement_id')"
                          type="button"
                          class="btn-outline-dark p-0 ml-3 btn-rounded btn-lg remove-item transform scale-150"
                        >
                          <XCircleIcon class="btn-source-icon" />
                        </button>
                      </div>

                      <textarea
                        :id="`supplement-description-${s.id}`"
                        v-model="s.description"
                        :placeholder="$t(`${viewRoot}.interactions.supplements.placeholder`, { supplement: s.name })"
                        class="form-control w-full"
                      >
                      </textarea>
                      <div
                        v-if="
                          validations.supplementInteractions === 'missing_description' &&
                          (!s.description || !s.description.trim())
                        "
                        class="text-theme-6 mt-2 text-sm"
                      >
                        {{
                          $t("views.supplements.validations.description_required") ||
                          `Debes completar la descripción de esta interacción`
                        }}
                      </div>
                    </div>
                  </template>
                </fieldset>
                <!-- Interactions of supplements:end -->

                <hr class="my-3" />

                <!-- Interactions of diseases:start -->
                <fieldset>
                  <div class="input-group rounded relative">
                    <TomSelect
                      class="w-full cursor"
                      v-model="supplement.interactions.sickness"
                      :placeholder="$t('views.supplements.text88')"
                      :plugins="['dropdown_input']"
                      v-on:change="addInteraction('sicknesses', 'sickness')"
                    >
                      <option value="0">
                        {{ $t("views.supplements.text88") }}
                      </option>

                      <option
                        v-for="sickness in supplement.interactions.sicknesses"
                        :key="sickness.disease_id"
                        :disabled="sickness.active"
                        :value="sickness.disease_id"
                      >
                        {{ sickness.name }}
                      </option>
                    </TomSelect>
                    <div
                      class="input-group-text btn border-0 flex items-center justify-center p-2 ml-1"
                      @click="openDiseaseQuickCreateModal"
                      style="cursor: pointer"
                    >
                      <PlusIcon class="w-4 h-4" />
                    </div>
                  </div>

                  <template v-for="d in supplement.interactions.sicknesses.filter((s) => s.active)" :key="d.disease_id">
                    <div class="intro-x border-custom-gray-8 border-1 rounded-lg px-6 pb-6 my-3">
                      <div class="w-full flex justify-between">
                        <label
                          :for="`disease-description-${d.disease_id}`"
                          class="py-3 cursor-pointer flex items-center gap-1"
                          title="Ver enfermedad"
                          @click="goToDisease(d.disease_id)"
                        >
                          {{ d.name }}
                          <LinkIcon class="btn-source-icon" />
                        </label>

                        <button
                          v-on:click="removeInteraction(d, 'sicknesses', 'disease_id')"
                          type="button"
                          class="btn-outline-dark p-0 ml-3 btn-rounded btn-lg remove-item transform scale-150"
                        >
                          <XCircleIcon class="btn-source-icon" />
                        </button>
                      </div>

                      <textarea
                        :id="`disease-description-${d.disease_id}`"
                        v-model="d.description"
                        :placeholder="$t(`${viewRoot}.interactions.diseases.placeholder`, { disease: d.name })"
                        class="form-control w-full"
                      >
                      </textarea>

                      <!-- Mensaje de validación -->
                      <div
                        v-if="
                          validations.diseaseInteractions === 'missing_description' &&
                          (!d.description || !d.description.trim())
                        "
                        class="text-theme-6 mt-2 text-sm"
                      >
                        {{ $t("views.supplements.validations.description_required") }}
                      </div>
                    </div>
                  </template>
                </fieldset>
                <!-- Interactions of diseases:end -->

                <hr class="my-3" />

                <!-- Interactions of medicines:start -->
                <div class="mt-3">
                  <label for="crud-form-3" class="form-label font-semibold">
                    {{ $t("views.supplements.text89") }}
                  </label>

                  <div class="grid gap-6">
                    <div
                      v-for="(medicine, medicineKey) in supplement.interactions.medicines"
                      :key="medicineKey"
                      class="border-custom-gray-8 border-1 rounded-lg p-6 field__medicine"
                      :class="{
                        medicine__deleted: medicine.deleted,
                      }"
                    >
                      <div class="input-group gap-5">
                        <div class="w-1/3 deleted__field__disabled">
                          <label :for="`medication-class-select-${medicineKey}`" class="form-label">
                            {{ $t("views.supplements.text90") }}
                          </label>

                          <div class="input-group input-bg-theme-32 rounded relative">
                            <TomSelect
                              :id="`medication-class-select-${medicineKey}`"
                              class="w-full cursor"
                              v-model="medicine.medication_class_id"
                              :placeholder="$t('views.supplements.text91')"
                              @change="updateGenericOptions(medicine)"
                              :disabled="medicine.deleted"
                            >
                              <option value="null">{{ $t("views.supplements.text91") }}</option>

                              <option
                                v-for="m in medicines"
                                :key="m.medication_class_id"
                                :value="m.medication_class_id"
                              >
                                {{ m.name }}
                              </option>
                            </TomSelect>

                            <div
                              class="input-group-text btn border-0 flex items-center justify-center p-2"
                              @click="!medicine.deleted && openFamilyQuickCreateModal(medicineKey)"
                              :class="{ 'opacity-50 cursor-not-allowed': medicine.deleted }"
                              style="cursor: pointer"
                            >
                              <PlusIcon class="w-4 h-4" />
                            </div>
                          </div>
                        </div>

                        <div class="w-1/3 deleted__field__disabled">
                          <label :for="`medication-generic-select-${medicineKey}`" class="form-label">
                            {{ $t("views.supplements.text92") }}
                          </label>

                          <div class="input-group input-bg-theme-32 rounded relative">
                            <TomSelect
                              :id="`medication-generic-select-${medicineKey}`"
                              class="w-full cursor"
                              v-model="medicine.generic"
                              :placeholder="$t('views.supplements.text90')"
                              @change="addMedicineItem(medicine)"
                            >
                              <option value="null">{{ $t("views.supplements.text91") }}</option>

                              <option
                                v-for="item in medicine.medication_class_drugs || []"
                                :key="item.drug_id"
                                :value="item.drug_id"
                                :disabled="item.active"
                              >
                                {{ item.name }}
                              </option>
                            </TomSelect>

                            <div
                              class="input-group-text btn border-0 flex items-center justify-center p-2"
                              @click="
                                !(
                                  medicine.deleted ||
                                  !medicine.medication_class_id ||
                                  medicine.medication_class_id === 'null' ||
                                  medicine.medication_class_id === '0'
                                ) && openDrugQuickCreateModal(medicine, medicineKey)
                              "
                              :class="{
                                'opacity-50 cursor-not-allowed':
                                  medicine.deleted ||
                                  !medicine.medication_class_id ||
                                  medicine.medication_class_id === 'null' ||
                                  medicine.medication_class_id === '0',
                              }"
                              style="cursor: pointer"
                            >
                              <PlusIcon class="w-4 h-4" />
                            </div>
                          </div>
                        </div>

                        <div class="w-1/3 deleted__field__disabled">
                          <label :for="`medication-level-select-${medicineKey}`" class="form-label">
                            {{ $t("views.supplements.text97") }}
                          </label>

                          <TomSelect
                            :id="`medication-level-select-${medicineKey}`"
                            class="w-full cursor"
                            v-model="medicine.level"
                            :placeholder="$t('views.supplements.text90')"
                            :input_hide="true"
                          >
                            <option value="null">{{ $t("views.supplements.text91") }}</option>

                            <option v-for="(item, itemKey) in levels" :key="itemKey" :value="item.value">
                              {{ item.name }}
                            </option>
                          </TomSelect>
                        </div>

                        <div class="w-auto pr-2 flex justify-end items-start">
                          <button
                            v-if="!medicine.deleted"
                            @click="updateStatusMedicine(medicine)"
                            type="button"
                            class="btn-outline-dark p-0 btn-rounded btn-md remove-item transition-opacity"
                            :disabled="supplement.interactions.medicines.length === 1"
                            :class="{
                              'opacity-40 cursor-not-allowed': supplement.interactions.medicines.length === 1,
                              'opacity-100 cursor-pointer': supplement.interactions.medicines.length > 1,
                            }"
                          >
                            <XCircleIcon class="btn-source-icon w-6 h-6" />
                          </button>

                          <button
                            v-else
                            @click="updateStatusMedicine(medicine, false)"
                            type="button"
                            class="btn-outline-dark btn-rounded btn-md tooltip"
                          >
                            <RotateCcwIcon />
                            <span class="tooltip__text">{{ $t(`${viewRoot}.interactions.medicines.restore`) }}</span>
                          </button>
                        </div>
                      </div>

                      <div
                        v-if="medicine.action_mechanism && medicine.action_mechanism.trim() !== ''"
                        class="deleted__field__hidden mt-6"
                      >
                        <label class="form-label font-semibold">
                          {{ $t("views.supplements.text93") }}
                        </label>
                        <p
                          class="text-gray-600 dark:text-gray-400 whitespace-pre-line bg-gray-100 dark:bg-dark-1 p-3 rounded-lg border border-custom-gray-8"
                        >
                          {{ medicine.action_mechanism }}
                        </p>
                      </div>

                      <div class="deleted__field__hidden mt-6">
                        <label :for="`medicine-description-${medicineKey}`" class="form-label">
                          {{ $t("views.supplements.text7") }}
                        </label>

                        <textarea
                          :id="`medicine-description-${medicineKey}`"
                          type="text"
                          v-model="medicine.description"
                          class="form-control"
                          :placeholder="
                            $t('views.supplements.interactions.medicines.placeholders.medicine_description')
                          "
                          rows="5"
                        />
                      </div>

                      <div class="deleted__field__hidden mt-6">
                        <label :for="`medicine-source-${medicineKey}`" class="form-label">
                          {{ $t("views.supplements.text41") }}
                        </label>

                        <input
                          :id="`medicine-source-${medicineKey}`"
                          type="text"
                          class="form-control"
                          :placeholder="
                            $t('views.supplements.text42') + ': https://www.medicalresearch.com/sources/evidence.pdf'
                          "
                          v-model="medicine.source"
                          v-on:keyup="
                            (event) => {
                              medicineSourceAdd(event, medicine);
                            }
                          "
                          @focusout="
                            (event) => {
                              medicineSourceAdd(event, medicine);
                            }
                          "
                        />
                      </div>

                      <div class="deleted__field__hidden mt-5" v-if="medicine.sources.length > 0">
                        <div
                          class="flex items-center"
                          v-for="(val, key) in medicine.sources"
                          :key="key"
                          :value="val.id"
                        >
                          <div class="items-center w-full relative" v-if="val.edit == false">
                            <div class="intro-x">
                              <div class="box border px-5 mb-3 flex items-center">
                                <div class="flex h-10 items-center justify-center">
                                  <LinkIcon class="btn-source-icon" />
                                </div>

                                <div class="ml-4 mr-auto">
                                  <div class="font-medium">
                                    {{ val.source }}
                                  </div>
                                </div>

                                <button
                                  v-on:click="val.edit = true"
                                  type="button"
                                  class="ml-5 btn-outline-dark btn-rounded btn-sm"
                                >
                                  <EditIcon class="btn-source-icon" />
                                </button>

                                <button
                                  v-on:click="medicineSourceDelete(val, medicine)"
                                  type="button"
                                  class="btn-outline-dark btn-rounded btn-sm"
                                >
                                  <Trash2Icon class="btn-source-icon" />
                                </button>
                              </div>
                            </div>

                            <div
                              class="absolute"
                              style="width: 80%; height: 100%; top: 0; left: 0; cursor: pointer; z-index: 999"
                              @click="goSource(val.source)"
                            ></div>
                          </div>

                          <div v-else class="block w-full">
                            <div class="input-group w-full mb-3">
                              <input
                                :id="`medicine-source-else-${key}`"
                                type="text"
                                class="form-control"
                                :placeholder="
                                  $t('views.supplements.text42') +
                                  ': https://www.medicalresearch.com/sources/evidence.pdf'
                                "
                                v-model="val.source"
                              />

                              <div class="input-group-text btn" @click="medicineSourceEdit(val, medicine)">
                                <SaveIcon />
                              </div>
                            </div>

                            <div v-if="val.error" class="text-theme-6 mt-2">
                              {{ $t("views.supplements.text43") }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Add new medicine -->
                      <div class="deleted__field__hidden mt-4">
                        <button
                          @click="addMedicine()"
                          type="button"
                          class="btn btn-primary disabled:opacity-50 disabled:cursor-not-allowed"
                          :disabled="!isMedicineComplete(medicine)"
                        >
                          {{ $t("views.supplements.new_medicine") }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Visual error message only if user starts filling data and leaves it blank -->
                  <div v-if="validations.medicineFields === 'empty'" class="text-theme-6 mt-2">
                    {{ $t("views.supplements.validations.missing_medicine_fields") }}
                  </div>

                  <div v-if="validations.medicineDuplicate" class="text-theme-6 mt-2">
                    {{ $t("views.supplements.validations.duplicated_medicine") }}
                  </div>
                </div>
                <!-- Interactions of medicines:end -->
              </div>

              <hr class="my-10" />

              <!-- campo fuentes de evidencia -->
              <label for="crud-form-3" class="form-label font-semibold text-lg">
                {{ $t("views.supplements.text41") }}
              </label>

              <!-- campo fuentes de occidente -->
              <div class="mt-2">
                <label class="form-label font-normal text-base">
                  {{ $t("views.supplements.text74") }}
                </label>

                <!-- Dropdown to select Western Platform -->
                <div class="w-full mb-4">
                  <div class="input-group input-bg-theme-32 rounded relative">
                    <TomSelect
                      class="w-full cursor"
                      v-model="selectedWesternPlatform"
                      v-on:change="addWesternSource(selectedWesternPlatform)"
                      :placeholder="$t('views.supplements.text74')"
                      :plugins="['dropdown_input']"
                    >
                      <option value="">{{ $t("views.supplements.text74") }}...</option>
                      <option v-for="platform in westernPlatforms" :key="platform.id" :value="platform.id">
                        {{ platform.name }}
                      </option>
                    </TomSelect>
                    <div
                      class="input-group-text btn border-0 flex items-center justify-center p-2"
                      @click="openPlatformQuickCreateModal('WESTERN')"
                      style="cursor: pointer"
                    >
                      <PlusIcon class="w-4 h-4" />
                    </div>
                  </div>
                </div>

                <!-- List of added Western Sources -->
                <div
                  class="w-full mb-6 border-1 border-custom-gray-8 rounded-lg p-4"
                  v-for="(source, idx) in supplement.scienceSources.east"
                  :key="'east-' + idx"
                >
                  <div class="flex justify-between items-center mb-2">
                    <label class="form-label font-bold text-white text-base">{{ source.platformName }}</label>
                    <button type="button" class="btn border-custom-gray-8 btn-sm p-1" @click="removeWesternSource(idx)">
                      <Trash2Icon class="w-4 h-4 text-white btn-source-icon" />
                    </button>
                  </div>

                  <div class="input-group gap-5">
                    <div class="flex flex-col w-full sm:flex-row items-center gap-3">
                      <!-- URL -->
                      <div class="w-full">
                        <input
                          type="url"
                          class="form-control w-full"
                          :placeholder="$t('views.supplements.text42')"
                          v-model="source.url"
                          @blur="validateURLs"
                        />
                        <div v-if="source.urlError" class="text-theme-6 mt-2">
                          {{ $t("views.supplements.text43") }} ({{ source.urlError }})
                        </div>
                      </div>
                      <!-- Platform ID -->
                      <div class="w-full">
                        <input
                          type="text"
                          class="form-control w-full"
                          placeholder="Platform ID"
                          v-model="source.platformReferenceId"
                        />
                      </div>
                      <!-- DOI -->
                      <div class="w-full">
                        <input type="text" class="form-control w-full" placeholder="DOI" v-model="source.doi" />
                      </div>
                    </div>
                  </div>

                  <!-- Comentarios -->
                  <div class="mt-3">
                    <div class="input-group">
                      <textarea
                        type="text"
                        class="form-control"
                        :class="source.descriptionError ? 'border border-theme-6' : ''"
                        :placeholder="$t('views.supplements.text76')"
                        aria-describedby="input-group-1"
                        rows="3"
                        v-model="source.description"
                        maxlength="500"
                      />
                    </div>
                    <div v-if="source.descriptionError" class="text-theme-6 mt-2">
                      {{ $t("views.supplements.text95") }}
                    </div>
                  </div>
                </div>

                <div v-if="validations.eastSources === 'min'" class="text-theme-6 mt-2 mb-4">
                  {{ $t("views.supplements.errorEastSources") }}
                </div>
              </div>

              <!-- campo fuentes de oriente -->
              <div class="mt-4">
                <label class="form-label font-normal text-base">
                  {{ $t("views.supplements.text75") }}
                </label>

                <!-- Dropdown to select Eastern Platform -->
                <div class="w-full mb-4">
                  <div class="input-group input-bg-theme-32 rounded relative">
                    <TomSelect
                      class="w-full cursor"
                      v-model="selectedEasternPlatform"
                      v-on:change="addEasternSource(selectedEasternPlatform)"
                      :placeholder="$t('views.supplements.text75')"
                      :plugins="['dropdown_input']"
                    >
                      <option value="">{{ $t("views.supplements.text75") }}...</option>
                      <option v-for="platform in easternPlatforms" :key="platform.id" :value="platform.id">
                        {{ platform.name }}
                      </option>
                    </TomSelect>
                    <div
                      class="input-group-text btn border-0 flex items-center justify-center p-2"
                      @click="openPlatformQuickCreateModal('EASTERN')"
                      style="cursor: pointer"
                    >
                      <PlusIcon class="w-4 h-4" />
                    </div>
                  </div>
                </div>

                <!-- List of added Eastern Sources -->
                <div
                  class="w-full mb-6 border-custom-gray-8 border-1 rounded-lg p-4"
                  v-for="(source, idx) in supplement.scienceSources.west"
                  :key="'west-' + idx"
                >
                  <div class="flex justify-between items-center mb-2">
                    <label class="form-label font-bold text-white text-base">{{ source.platformName }}</label>
                    <button type="button" class="btn border-custom-gray-8 btn-sm p-1" @click="removeEasternSource(idx)">
                      <Trash2Icon class="w-4 h-4 text-white btn-source-icon" />
                    </button>
                  </div>

                  <div class="input-group gap-5">
                    <div class="flex flex-col w-full sm:flex-row items-center gap-3">
                      <!-- URL -->
                      <div class="w-full">
                        <input
                          type="url"
                          class="form-control w-full"
                          :placeholder="$t('views.supplements.text42')"
                          v-model="source.url"
                          @blur="validateURLs"
                        />
                        <div v-if="source.urlError" class="text-theme-6 mt-2">
                          {{ $t("views.supplements.text43") }} ({{ source.urlError }})
                        </div>
                      </div>
                      <!-- Platform ID -->
                      <div class="w-full">
                        <input
                          type="text"
                          class="form-control w-full"
                          placeholder="Platform ID"
                          v-model="source.platformReferenceId"
                        />
                      </div>
                      <!-- DOI -->
                      <div class="w-full">
                        <input type="text" class="form-control w-full" placeholder="DOI" v-model="source.doi" />
                      </div>
                    </div>
                  </div>

                  <!-- Comentarios -->
                  <div class="mt-3">
                    <div class="input-group">
                      <textarea
                        type="text"
                        class="form-control"
                        :class="source.descriptionError ? 'border border-theme-6' : ''"
                        :placeholder="$t('views.supplements.text76')"
                        aria-describedby="input-group-1"
                        rows="3"
                        v-model="source.description"
                        maxlength="500"
                      />
                    </div>
                    <div v-if="source.descriptionError" class="text-theme-6 mt-2">
                      {{ $t("views.supplements.text95") }}
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="validations.westSources === 'min'" class="text-theme-6 mt-2">
                {{ $t("views.supplements.errorWestSources") }}
              </div>
              <hr class="my-10" />
              <!-- campo de conclusiones generales -->
              <div class="mt-4">
                <label for="crud-form-3" class="form-label">
                  {{ $t("views.supplements.text73") }}
                </label>
                <div class="input-group">
                  <textarea
                    id="crud-form-3"
                    type="text"
                    class="form-control"
                    :class="validations[`comments_${lang_key}`] ? 'border border-theme-6' : ''"
                    :placeholder="$t('views.supplements.text73')"
                    aria-describedby="input-group-1"
                    rows="6"
                    v-model="supplement.langs[lang_key].comments"
                    maxlength="500"
                  />
                </div>
                <div v-if="validations[`comments_${lang_key}`]" class="text-theme-6 mt-2">
                  {{
                    lang_key === "es"
                      ? $t("views.supplements.validations.comment_es_required")
                      : $t("views.supplements.validations.comment_en_required")
                  }}
                </div>
              </div>
            </div>
            <!-- END: Form Layout -->
          </div>
        </div>

        <!-- campo ESTADO -->
        <div class="season pl-5 pt-1 box">
          <StatusSelector
            v-if="supplement"
            v-model="supplement.status"
            :original-status="supplement.originalStatus"
            :label="$t('views.supplements.text94')"
            :status-labels="{
              APPROVED: $t('views.approved'),
              REJECTED: $t('views.disapproved'),
              PENDING_APPROVAL: $t('views.to_be_approved'),
            }"
            :view-root="'views.supplements'"
            :error="validations?.status ? $t('views.supplements.text94') : ''"
            @confirmed-change="supplement.originalStatus = supplement.status"
          />
        </div>

        <div class="text-right p-5 box">
          <!-- Botón eliminar (solo si existe supplement.id) -->
          <button
            v-if="supplement.id"
            @click="confirmRemoveSupplement"
            type="button"
            class="btn btn-outline-dark w-24 mr-5"
          >
            <LoadingIcon v-if="removeLoading" icon="three-dots" />
            <span v-else>{{ $t("views.delete") }}</span>
          </button>

          <!-- Botón guardar temporal -->
          <button @click="saveTempSupplement()" type="button" class="btn btn-outline-dark w-36 mr-5">
            <LoadingIcon v-if="loading" icon="three-dots" />
            <span v-else>{{ $t("views.save_temp") }}</span>
          </button>

          <!-- Botón guardar -->
          <button @click="saveSupplement" type="button" class="btn btn-primary w-24">
            <LoadingIcon v-if="loading" icon="three-dots" />
            <span v-else>{{ $t("views.save") }}</span>
          </button>
        </div>
      </div>
    </div>
    <!-- Main content:end -->

    <BenefitQuickCreateModal ref="benefitQuickCreateModal" @created="handleBenefitCreated" />
    <PurposeQuickCreateModal ref="purposeQuickCreateModal" @created="handlePurposeCreated" />
    <SupplementQuickCreateModal ref="supplementQuickCreateModal" @created="handleSupplementQuickCreated" />
    <ProblemQuickCreateModal ref="problemQuickCreateModal" @created="handleProblemCreated" />
    <DiseaseQuickCreateModal ref="diseaseQuickCreateModal" @created="handleDiseaseCreated" />
    <PlatformQuickCreateModal ref="platformQuickCreateModal" @created="handlePlatformCreated" />
    <FamilyQuickCreateModal ref="familyQuickCreateModal" @created="handleFamilyCreated" />
    <DrugQuickCreateModal
      ref="drugQuickCreateModal"
      :medication-class-id="activeFamilyId"
      @created="handleDrugCreated"
    />
    <AlertMessage ref="alertMessage" id_alert="general-alert" />
    <AlertMessage ref="alertContinueSupplement" id_alert="continue-supplement-alert" />
  </div>
</template>

<script>
import ConfirmMessages from "@/components/message/ConfirmMessages.vue";
import Message from "@/components/message/Message.vue";

import SupplementService from "@/services/supplements.service";
import UtilitiesService from "@/services/utilities.service";
import MedicationService from "@/services/medications.service";
import DiseaseService from "@/services/diseases.service";
import NutrihubService from "@/services/nutrihub.service";
import ScienceSourceService from "@/services/science-source.service";
import SupplementsLocalService from "@/services/local/supplements.local.service";
import AgeRangesSelect from "@/components/age-ranges-select/Main.vue";
import Toastify from "toastify-js";
import StatusSelector from "@/components/status-selector/Main.vue";
import AlertMessage from "@/components/alert/Main.vue";
import BenefitQuickCreateModal from "@/views/supplements/benefits/BenefitQuickCreateModal.vue";
import PurposeQuickCreateModal from "@/views/supplements/purposes/PurposeQuickCreateModal.vue";
import SupplementQuickCreateModal from "@/views/supplements/SupplementQuickCreateModal.vue";
import ProblemQuickCreateModal from "@/views/supplements/problems/ProblemQuickCreateModal.vue";
import DiseaseQuickCreateModal from "@/views/disease/DiseaseQuickCreateModal.vue";
import PlatformQuickCreateModal from "@/views/science-source/platforms/PlatformQuickCreateModal.vue";
import FamilyQuickCreateModal from "@/views/medication/family/FamilyQuickCreateModal.vue";
import DrugQuickCreateModal from "@/views/medication/DrugQuickCreateModal.vue";

import { countChars } from "@/utils/word_counter.js";
import { formatToSend } from "@/utils/modules/nutrihub/supplements";

export default {
  components: {
    ConfirmMessages,
    Message,
    AlertMessage,
    StatusSelector,
    AgeRangesSelect,
    BenefitQuickCreateModal,
    PurposeQuickCreateModal,
    SupplementQuickCreateModal,
    ProblemQuickCreateModal,
    DiseaseQuickCreateModal,
    PlatformQuickCreateModal,
    FamilyQuickCreateModal,
    DrugQuickCreateModal,
  },
  setup() {},
  computed: {
    westernPlatforms() {
      return this.allPlatforms.filter((p) => p.region_of_origin === "WESTERN");
    },
    easternPlatforms() {
      return this.allPlatforms.filter((p) => p.region_of_origin === "EASTERN");
    },
    otherLang() {
      const currentLangKey = this.lang_key;
      return (this.langs || []).find((l) => l.key !== currentLangKey) || { key: "es", name: "Spanish" };
    },
  },
  data() {
    return {
      viewRoot: "views.supplements",
      removeLoading: false,
      translating: false,
      missingSex: null,
      supplement: {
        langs: this.getLangsSupplement(),
        usedFor: [],
        benefits: [
          {
            id: null,
            posology: "",
            problemIds: [],
            score: { ec: 0, bd: 0, rc: 0, est: 0, totalScore: 0 },
          },
        ],
        doses: [
          {
            id: "",
            biologicalSex: "",
            ages: [],
            modality: "SPECIFIC",
            unit: "",
            specificValues: [null, null, null],
            rangeValues: [
              { min: null, max: null },
              { min: null, max: null },
              { min: null, max: null },
            ],
          },
        ],
        interactions: {
          supplement: 0,
          sickness: 0,
          medicine: "",
          supplements: [],
          sicknesses: [],
          medicines: [
            {
              id: "",
              medication_class_id: "",
              name: "",
              level: "",
              action_mechanism: "",
              description: "",
              generic: "",
              medication_class_drugs: [],
              source: "",
              sources: [],
              sources_deleted: [],
            },
          ],
        },
        effects: [],
        deficiencies: [],
        excesses: [],
        activities: [],
        sources: "",
        schedule: "",
        age: [],
        benefit: "",
        sex: "",
        aspect: 2,
        scienceSources: {
          east: [],
          west: [],
        },
        status: "PENDING_APPROVAL",
        originalStatus: "PENDING_APPROVAL",
      },

      // Categories of supplement
      allCategories: [],
      allPlatforms: [],
      selectedWesternPlatform: "",
      selectedEasternPlatform: "",
      allUsedFor: [],
      allBenefits: [],
      allPosologies: this.$global.getPosologyKey(),
      allProblems: [],
      allBiologicalSex: this.$global.getGenders(),
      allFields: [
        { label: "views.supplements.text69", type: "effects", input: "effect" },
        {
          label: "views.supplements.text70",
          type: "deficiencies",
          input: "deficiency",
        },
        {
          label: "views.supplements.text71",
          type: "excesses",
          input: "excess",
        },
        {
          label: "views.supplements.text72",
          type: "activities",
          input: "activity",
        },
      ],
      allSupplements: [],
      langValidations: {},
      validations: {} /* this.getInitialValidations() */,
      comments: {
        es: false,
        en: false,
      },
      loading: false,
      recomendations: null,
      status: false,
      queryUrl: this.$route.query,
      hiddenKey: ["id", "id_api", "food_id", "updatedAt", "createdAt", "deletedAt"],
      supplementCategories: [],
      sources: [],
      source: "",
      schedule: { form: "", count: null },
      // Para la validacion de la dosis en base al sexo biologico
      showSexConfirmation: false,
      sexToValidate: null,
      beneficios: [],
      ages: this.$global.getAgesRanges(),

      medicineValidationError: null,
      medicines: [],
      levels: [
        { value: "LOW", name: this.$t("views.supplements.interactions.medicines.levels.low") },
        { value: "MODERATE", name: this.$t("views.supplements.interactions.medicines.levels.medium") },
        { value: "HIGH", name: this.$t("views.supplements.interactions.medicines.levels.high") },
      ],
      vueFillAprobed: false,
      drugs_exist: [],
      class_drug_exist: [],
      // TODO: ELIMINAR ESTO
      actual_interaction_supplement: [],
      actual_interaction_diseases: [],

      aspect: this.$global.getAspect(),

      // UI
      initialLoading: true,
      messages: {
        savedSuccessId: "saved-confirmation-success",
        updatedSuccessId: "updated-confirmation-success",
        removedSuccessId: "removed-confirmation-success",
        savedTempSuccessId: "saved-temp-supplement-success",
      },
      // Auto-save
      AUTO_SAVE_INTERVAL_MS: 1000 * 60 * 1,
      autoSaveInterval: null,
      // languages
      activeLang: "lang__" + (localStorage.lang ? localStorage.lang : navigator.language.split("-")[0]),
      langs: this.$global.getLangs(),
      lang_key: localStorage.lang ? localStorage.lang : navigator.language.split("-")[0],
      global_lang: localStorage.lang ? localStorage.lang : navigator.language.split("-")[0],
      lang_inputs: [],
      currentMedicineRowKey: null,
      activeFamilyId: "",
    };
  },
  watch: {
    supplementCategories: function () {
      var categories = this.allCategories;
      this.supplementCategories.forEach(function (c) {
        var cat = categories.find(function (cc) {
          return cc.id == c;
        });
        if (!cat) {
          categories.push({ id: c, name: c, new: true });
        }
      });
      this.allCategories = categories;
    },
    "supplement.doses": {
      deep: true,
      handler(newVal) {
        const sexes = newVal.map((d) => d.biologicalSex).filter(Boolean);
        const uniqueSexes = [...new Set(sexes)];

        // Si el usuario corrigió el error (ya no hay un único sexo distinto de BOTH)
        if (uniqueSexes.length !== 1 || uniqueSexes[0] === "BOTH") {
          if (this.validations.doses === "empty") {
            this.validations.doses = null;
          }
          this.missingSex = null;
        }
      },
    },
    "$i18n.locale": function (l) {
      this.getDataInitial();
      this.loadCategories();
      this.loadAllSupplements();
      this.loadAllMedicines();
      this.loadAllDiseases();
      this.loadAllBenefits();
      this.loadAllProblems();
      this.loadAllPurposes();
      this.loadAllPlatforms();
    },
    activeLang: function () {
      this.lang_key = this.activeLang.replace("lang__", "");
    },
  },
  created() {
    this.verifiedAccess();
    this.preparedLangs();

    // Set supplement id
    this.setSupplementId();
  },
  mounted() {
    // Get Data (in mounted so $refs are available for the draft restore dialog)
    this.loadAllOptions();
    this.startAutoSave();
  },
  beforeUnmount() {
    this.stopAutoSave();
  },
  methods: {
    setSupplementId() {
      let id = this.$route.query.id || this.supplement.id || false;
      id = Number(id);
      if (!id || isNaN(id) || id < 1) return;
      this.supplement.id = id;
    },
    /**
     * *LOADS DATA
     */
    async loadAllOptions() {
      await Promise.all([
        this.loadCategories(),
        this.loadAllSupplements(),
        this.loadAllMedicines(),
        this.loadAllDiseases(),
        this.loadAllBenefits(),
        this.loadAllProblems(),
        this.loadAllPurposes(),
        this.loadAllPlatforms(),
      ]);

      await this.getSupplementById();

      this.initialLoading = false;
    },

    handleAgeChange(dose) {
      // Si selecciona "ALL", forzamos que solo quede "ALL"
      if (dose.ages.includes("ALL")) {
        dose.ages = ["ALL"];
      }
    },
    hasDuplicateBenefits() {
      const benefits = this.supplement.benefits;

      if (!Array.isArray(benefits) || benefits.length < 2) return false;

      // Normalizamos y filtramos solo los completos (un solo link por beneficio)
      const normalized = benefits
        .filter((b) => b.id && b.posology && b.problemIds?.length > 0)
        .map((b) => String(b.id).trim());

      // Si hay menos de dos completos, no puede haber duplicados
      if (normalized.length < 2) return false;

      const seen = new Set();

      for (const benefitId of normalized) {
        if (seen.has(benefitId)) {
          console.warn("⚠️ Beneficio duplicado detectado:", benefitId);
          return true; // detectó duplicado entre bloques distintos
        }
        seen.add(benefitId);
      }

      return false;
    },
    async getSupplementById() {
      // x const id = 1 // fijo para mock
      const id = this.supplement.id || false;

      if (!id) {
        // New supplement: check for a temporary draft
        await this.checkForDraft();
        return;
      }

      try {
        this.getSupplementInteraction();
        this.getDiseaseInteraction();
        this.getMedicineInteraction();

        const response = await NutrihubService.getSupplementById(id);

        if (!response || !response.data) {
          return;
        }

        const data = response.data;

        // Asegura que langs esté definido
        if (!this.langs || this.langs.length === 0) {
          return;
        }

        // Aplica el transformador
        this.setSupplementFromApi(data, this.langs);

        // Editing supplement: check for a local draft after the API data is loaded
        await this.checkForDraft();
      } catch (e) {}
    },

    setSupplementFromApi(apiData, langs = this.langs) {
      const langsStructure = this.getLangsSupplement();
      const entries = Object.entries(langsStructure);

      for (const [langKey] of entries) {
        const apiLang = apiData.langs.find((l) => l.lang === langKey);
        if (!apiLang) continue;

        langsStructure[langKey] = {
          ...langsStructure[langKey],
          name: apiLang.value || "",
          chemicalName: apiLang.chemical_name || "",
          familySupplement: apiLang.family_supplement || "",
          description: apiLang.description || "",
          comments: apiLang.comments || "",
        };
      }

      this.supplement = {
        ...this.supplement,
        id: apiData.id || null,
        langs: langsStructure,
        usedFor: (apiData.purposes || []).map((p) => String(p.purpose_id)),
        supplementCategories: (apiData.categories || []).map((c) => c.supplement_category_id),
        benefits: (apiData.benefit_links || []).map((b) => ({
          id: b.supplement_benefits_id ? String(b.supplement_benefits_id) : "",
          posology: b.schedule || "",
          problemIds: (b.problems || []).map((p) => String(p.problem_id)),
          score: {
            ec: b.scientific_evidence_score,
            bd: b.bioavailability_score,
            rc: b.clinical_results_score,
            est: b.side_effects_and_tolerance_score,
            totalScore: b.total_score,
          },
        })),
        doses: (apiData.doses || []).map((d) => ({
          id: d.id,
          ages: d.age_ranges.map((ag) => ag.age_range),
          biologicalSex: d.biological_sex,
          modality: d.modality,
          unit: d.dose_specified?.unit || d.dose_range?.unit || "",
          specificValues: d.dose_specified
            ? [d.dose_specified.optimal, d.dose_specified.recommendation, d.dose_specified.upper_limit]
            : [null, null, null],
          rangeValues: d.dose_range
            ? [
                { min: d.dose_range.optimal_min, max: d.dose_range.optimal_max },
                { min: d.dose_range.recommendation_min, max: d.dose_range.recommendation_max },
                { min: d.dose_range.upper_limit_min, max: d.dose_range.upper_limit_max },
              ]
            : [
                { min: null, max: null },
                { min: null, max: null },
                { min: null, max: null },
              ],
        })),
        effects: (apiData.side_effects || []).map((item) => ({
          id: item.id,
          langs: this.langs.reduce((acc, lang) => {
            const langData = item.langs.find((l) => l.lang === lang.key);
            acc[lang.key] = {
              id: langData?.id ?? null,
              text: langData?.value || "",
              edit: false,
              error: false,
              validation: {
                active: false,
                text: "",
              },
            };
            return acc;
          }, {}),
        })),
        deficiencies: (apiData.symptoms_of_deficiencies || []).map((item) => ({
          id: item.id,
          langs: this.langs.reduce((acc, lang) => {
            const langData = item.langs.find((l) => l.lang === lang.key);
            acc[lang.key] = {
              id: langData?.id ?? null,
              text: langData?.value || "",
              edit: false,
              error: false,
              validation: {
                active: false,
                text: "",
              },
            };
            return acc;
          }, {}),
        })),
        activities: (apiData.synergistic_activities || []).map((item) => ({
          id: item.id,
          langs: this.langs.reduce((acc, lang) => {
            const langData = item.langs.find((l) => l.lang === lang.key);
            acc[lang.key] = {
              id: langData?.id ?? null,
              text: langData?.value || "",
              edit: false,
              error: false,
              validation: {
                active: false,
                text: "",
              },
            };
            return acc;
          }, {}),
        })),
        excesses: (apiData.symptoms_of_overs || []).map((item) => ({
          id: item.id,
          langs: this.langs.reduce((acc, lang) => {
            const langData = item.langs.find((l) => l.lang === lang.key);
            acc[lang.key] = {
              id: langData?.id ?? null,
              text: langData?.value || "",
              edit: false,
              error: false,
              validation: {
                active: false,
                text: "",
              },
            };
            return acc;
          }, {}),
        })),
        scienceSources: this.mapScienceSources(apiData.recommendation_supplement_science_sources),
        effect: "", // type input
        deficiency: "", // type input
        excess: "", // type input
        activity: "", // type input
      };

      if (this.supplement.benefits.length === 0) {
        this.supplement.benefits.push({
          id: null,
          posology: "",
          problemIds: [],
          score: { ec: 0, bd: 0, rc: 0, est: 0, totalScore: 0 },
        });
      }

      if (this.supplement.doses.length === 0) {
        this.supplement.doses.push({
          id: "",
          biologicalSex: "",
          ages: [],
          modality: "SPECIFIC",
          unit: "",
          specificValues: [null, null, null],
          rangeValues: [
            { min: null, max: null },
            { min: null, max: null },
            { min: null, max: null },
          ],
        });
      }

      this.supplementCategories = [...this.supplement.supplementCategories];
    },

    mapScienceSources(sources = []) {
      const east = [];
      const west = [];

      for (const item of sources) {
        if (!item.science_source) continue;
        const pId = item.science_source.platform_science_source_id;
        const platform = this.allPlatforms.find((p) => p.id == pId);

        const entry = {
          id: item.science_source.id,
          platformId: pId,
          platformName: platform ? platform.name : "",
          url: item.science_source.link,
          description: item.science_source.description || "",
          platformReferenceId: item.science_source.platform_reference_id || "",
          doi: item.science_source.doi || "",
          urlError: false,
          descriptionError: false,
        };

        if (platform && platform.region_of_origin === "WESTERN") {
          east.push(entry);
        } else if (platform && platform.region_of_origin === "EASTERN") {
          west.push(entry);
        } else {
          // Fallback based on old IDs
          if (pId <= 8) {
            east.push(entry);
          } else {
            west.push(entry);
          }
        }
      }

      return { east, west };
    },

    mockData() {
      this.supplement = {
        ...this.supplement,
        id: null,
        langs: {
          es: {
            name: "es: nombre comercial",
            chemicalName: "es: nombre quimico",
            familySupplement: "es: tipo variedad",
            description: "es: descripcion",
            comments: "es: comentario general ",
          },
          en: {
            name: "en: nombre comercial",
            chemicalName: "en: quimico",
            familySupplement: "en: variedad",
            description: "en: descipcion",
            comments: "en: comentario general",
          },
        },
        usedFor: [2, 7, 1, 21, 18],
        benefits: [
          {
            id: "3",
            posology: "WITH_FOOD",
            problemIds: ["3"],
            score: { bd: 0, ec: 0, est: 10, rc: 0, totalScore: 1 },
          },
          {
            id: "44",
            posology: "AFTER_WORKOUT",
            problemIds: ["1"],
            score: { ec: 10, bd: 8, rc: 6, est: 4, totalScore: 8 },
          },
          {
            id: "4",
            posology: "AFTER_WORKOUT",
            problemIds: ["1"],
            score: { ec: 10, bd: 8, rc: 6, est: 4, totalScore: 8 },
          },
        ],
        doses: [
          {
            ages: ["AR_18_24"],
            biologicalSex: "MALE",
            id: "",
            modality: "RANGE",
            unit: "mg",
            rangeValues: [
              { min: "15", max: "150" },
              { min: "1550", max: "1600" },
              { min: "1800", max: "2000" },
            ],
            specificValues: [null, null, null],
          },
          {
            ages: ["ALL"],
            biologicalSex: ["FEMALE"],
            id: "",
            modality: "SPECIFIC",
            unit: "g",
            rangeValues: [
              { min: null, max: null },
              { min: null, max: null },
              { min: null, max: null },
            ],
            specificValues: ["10", "100", "300"],
          },
        ],
        effects: [
          {
            id: null,
            langs: {
              es: {
                id: null,
                lang: "es",
                text: "es: efecto1",
                edit: false,
                error: false,
                validation: {
                  active: false,
                  text: "",
                },
              },
              en: {
                id: null,
                lang: "en",
                text: "en: efecto1",
                edit: false,
                error: false,
                validation: {
                  active: false,
                  text: "",
                },
              },
            },
          },
          {
            id: null,
            langs: {
              es: {
                id: null,
                lang: "es",
                text: "es: efecto2",
                edit: false,
                error: false,
                validation: {
                  active: false,
                  text: "",
                },
              },
              en: {
                id: null,
                lang: "en",
                text: "en: efecto2",
                edit: false,
                error: false,
                validation: {
                  active: false,
                  text: "",
                },
              },
            },
          },
        ],
        deficiencies: [
          {
            id: null,
            langs: {
              es: {
                id: null,
                lang: "es",
                text: "es: deficiencia",
                edit: false,
                error: false,
                validation: {
                  active: false,
                  text: "",
                },
              },
              en: {
                id: null,
                lang: "en",
                text: "en: deficiencia",
                edit: false,
                error: false,
                validation: {
                  active: false,
                  text: "",
                },
              },
            },
          },
          {
            id: null,
            langs: {
              es: {
                id: null,
                lang: "es",
                text: "es: deficiencia2",
                edit: false,
                error: false,
                validation: {
                  active: false,
                  text: "",
                },
              },
              en: {
                id: null,
                lang: "en",
                text: "en: deficiencia2",
                edit: false,
                error: false,
                validation: {
                  active: false,
                  text: "",
                },
              },
            },
          },
        ],
        excesses: [
          {
            id: null,
            langs: {
              es: {
                id: null,
                lang: "es",
                text: "es: exceso",
                edit: false,
                error: false,
                validation: {
                  active: false,
                  text: "",
                },
              },
              en: {
                id: null,
                lang: "en",
                text: "en: exceso",
                edit: false,
                error: false,
                validation: {
                  active: false,
                  text: "",
                },
              },
            },
          },
          {
            id: null,
            langs: {
              es: {
                id: null,
                lang: "es",
                text: "es: exceso2",
                edit: false,
                error: false,
                validation: {
                  active: false,
                  text: "",
                },
              },
              en: {
                id: null,
                lang: "en",
                text: "en: exceso2",
                edit: false,
                error: false,
                validation: {
                  active: false,
                  text: "",
                },
              },
            },
          },
        ],
        activities: [
          {
            id: null,
            langs: {
              es: {
                id: null,
                lang: "es",
                text: "es: sinergia",
                edit: false,
                error: false,
                validation: {
                  active: false,
                  text: "",
                },
              },
              en: {
                id: null,
                lang: "en",
                text: "en: sinergia",
                edit: false,
                error: false,
                validation: {
                  active: false,
                  text: "",
                },
              },
            },
          },
          {
            id: null,
            langs: {
              es: {
                id: null,
                lang: "es",
                text: "es: sinergia2",
                edit: false,
                error: false,
                validation: {
                  active: false,
                  text: "",
                },
              },
              en: {
                id: null,
                lang: "en",
                text: "en: sinergia2",
                edit: false,
                error: false,
                validation: {
                  active: false,
                  text: "",
                },
              },
            },
          },
        ],
        scienceSources: {
          east: [],
          west: [],
        },
      };
      this.supplementCategories = [8, 9, 2];
    },
    countChars,

    validateSexDoses(force = false) {
      const sexes = this.supplement.doses.map((d) => d.biologicalSex).filter(Boolean);
      const uniqueSexes = [...new Set(sexes)];

      // Caso válido: BOTH o ambos sexos
      if (uniqueSexes.includes("BOTH") || (uniqueSexes.includes("MALE") && uniqueSexes.includes("FEMALE"))) {
        this.missingSex = null;
        this.validations.doses = false;
        return true;
      }

      // Caso inválido: solo un sexo
      if (uniqueSexes.length === 1 && uniqueSexes[0] !== "BOTH") {
        this.missingSex =
          uniqueSexes[0] === "MALE" ? this.$t("globals.biological_sex.FEMALE") : this.$t("globals.biological_sex.MALE");

        // siempre marcamos error visual
        this.validations.doses = "empty";

        if (!force) {
          const styleInline = 'style="text-wrap: pretty;"';
          const message = `
        <h2 class="text-2xl mb-5 font-bold" ${styleInline}>
          ${this.$t("views.supplements.sex_warning_title")}
        </h2>
        <p ${styleInline}>
          ${this.$t("views.supplements.sex_warning_text")}
          <br><b>${this.missingSex}</b>
        </p>
      `;
          return false;
        }
      }

      return true;
    },

    validateRequiredField(value, min = 3, max = 35) {
      if (!value?.trim()) return "empty";
      if (countChars(value) < min || countChars(value) > max) return "range";
      return false;
    },

    getPayloadSupplement() {
      return {
        name: "Supplement2",
        langs: [
          {
            lang: "es", // ENUM(es, en)
            value: "Supplemento1",
            family_supplement: "Familia 1",
            chemical_name: "Nombre quimico",
            description: "description one",
            comments: "comments 1",
          },
          {
            lang: "en", // ENUM(es, en)
            value: "Supplement1",
            family_supplement: "Family 1",
            chemical_name: "chemical name 1",
            description: "description suppllement",
            comments: "coments",
          },
        ],
        supplement_categories: [
          {
            supplement_category_id: 1,
          },
        ],
        purposes: [
          {
            purpose_id: 1,
          },
        ],
        supplementBenefits: [
          {
            id: 1,
            problemIds: [1, 2],
            posology: "BEFORE_EAT", // ENUM(BEFORE_EAT, AFTER_EAT, AFTER_DINNER, AFTER_WORKOUT, WITH_FOOD, ANYTIME, 1_HR_BEFORE_SLEEP, FASTING, AT_NIGHT)
            score: {
              ec: 1.5,
              bd: 1.6,
              rc: 3.2,
              est: 2.3,
            },
          },
        ],
        doses: [
          // INCLUDES
          {
            age_range: ["AR_18_24"], // ENUM(ALL, AR_18_24, AR_25_35, AR_36_44, AR_45_54, AR_55_64, AR_65_79, AR_80_PLUS)
            dose_specified: {
              // include
              optimal: 1.2,
              recommendation: 2.3,
              upper_limit: 2.3,
            },
            dose_range: null,
            unit: "g",
            genre: "FEMALE", // ENUM(MALE, FEMALE, BOTH)
            modality: "SPECIFIC", // ENUM(SPECIFI, RANGE)
          },
          {
            age_range: "AR_25_35", // ENUM(ALL, AR_18_24, AR_25_35, AR_36_44, AR_45_54, AR_55_64, AR_65_79, AR_80_PLUS)
            dose_specified: null,
            dose_range: {
              // include
              optimal_min: 1.2,
              optimal_max: 2.2,
              recommendation_min: 3.2,
              recommendation_max: 4.5,
              upper_limit_min: 2.2,
              upper_limit_max: 2.5,
            },
            unit: "ml",
            genre: "FEMALE", // ENUM(MALE, FEMALE, BOTH)
            modality: "RANGE", // ENUM(SPECIFI, RANGE)
          },
        ],
        side_effects: [
          {
            value: "1",
          },
          {
            value: "2",
          },
        ],
        symptoms_of_over_supplementations: [
          {
            value: "1",
          },
          {
            value: "2",
          },
        ],
        symptoms_of_supplement_deficiencies: [
          {
            value: "1",
          },
          {
            value: "2",
          },
        ],
        synergistic_activities: [
          {
            value: "1",
          },
          {
            value: "2",
          },
        ],
        interactions: {
          supplements: [
            {
              supplement_id_2: 5,
            },
          ],
          diseases: [
            {
              disease_id: 1,
            },
          ],
          medicines: [
            {
              medication_class_id: "f941828b-ca78-435a-8e24-cf1ca480c1fb",
              drug_id: "2f2454e2-d8dc-4055-83f4-0c854bd72030",
              interaction_medication_supplement_detail: {
                // include
                action_mechanism: "",
                level: "HIGH", // ENUM(HIGH, MODERATE, LOW),
                description: "description",
                interaction_medication_supplement_detail_source: {
                  // include
                  source: "soruce1",
                },
              },
            },
          ],
        },
        recommendation_supplement_science_sources: [
          {
            science_source: {
              platform_science_source_id: 1,
              link: "www.sciencesource1.com",
              description: "sciencesourcedescription",
              hash: "0202010k2010",
            },
          },
        ],
      };
    },
    async translateFields() {
      if (!this.otherLang || !this.otherLang.key) return;
      const sourceLang = this.otherLang.key;
      const targetLang = this.lang_key;

      // Check if we have source language data
      const sourceData = this.supplement.langs[sourceLang] || {};
      const hasContent =
        sourceData.name || sourceData.description || sourceData.chemicalName || sourceData.familySupplement;
      if (!hasContent) {
        Toastify({
          text: `La pestaña de origen (${this.$t(
            "components.langs." + sourceLang + ".name"
          )}) está vacía. Completa algunos campos antes de traducir.`,
          duration: 3000,
          gravity: "top",
          position: "right",
          style: {
            background: "linear-gradient(to right, #e53935, #e35d5b)",
          },
        }).showToast();
        return;
      }

      this.translating = true;

      try {
        const payloadData = {
          name: sourceData.name || "",
          chemicalName: sourceData.chemicalName || "",
          familySupplement: sourceData.familySupplement || "",
          description: sourceData.description || "",
          comments: sourceData.comments || "",
          effects: (this.supplement.effects || []).map((x) => x.langs[sourceLang]?.text || ""),
          deficiencies: (this.supplement.deficiencies || []).map((x) => x.langs[sourceLang]?.text || ""),
          excesses: (this.supplement.excesses || []).map((x) => x.langs[sourceLang]?.text || ""),
          activities: (this.supplement.activities || []).map((x) => x.langs[sourceLang]?.text || ""),
        };

        const context = `Supplement Details Page Translation for supplement "${
          sourceData.name || "Supplement"
        }". Translating medical and longevity terminologies.`;

        const response = await UtilitiesService.translate({
          sourceLang,
          targetLang,
          context,
          data: payloadData,
        });

        if (response && response.success && response.data) {
          const translated = response.data;

          // Map core fields
          this.supplement.langs[targetLang].name = translated.name || "";
          this.supplement.langs[targetLang].chemicalName = translated.chemicalName || "";
          this.supplement.langs[targetLang].familySupplement = translated.familySupplement || "";
          this.supplement.langs[targetLang].description = translated.description || "";
          this.supplement.langs[targetLang].comments = translated.comments || "";

          // Map side effects
          if (Array.isArray(translated.effects)) {
            translated.effects.forEach((text, i) => {
              if (this.supplement.effects[i]) {
                this.ensureLangsForItem(this.supplement.effects[i]);
                this.supplement.effects[i].langs[targetLang].text = text || "";
              }
            });
          }

          // Map deficiencies
          if (Array.isArray(translated.deficiencies)) {
            translated.deficiencies.forEach((text, i) => {
              if (this.supplement.deficiencies[i]) {
                this.ensureLangsForItem(this.supplement.deficiencies[i]);
                this.supplement.deficiencies[i].langs[targetLang].text = text || "";
              }
            });
          }

          // Map excesses
          if (Array.isArray(translated.excesses)) {
            translated.excesses.forEach((text, i) => {
              if (this.supplement.excesses[i]) {
                this.ensureLangsForItem(this.supplement.excesses[i]);
                this.supplement.excesses[i].langs[targetLang].text = text || "";
              }
            });
          }

          // Map activities
          if (Array.isArray(translated.activities)) {
            translated.activities.forEach((text, i) => {
              if (this.supplement.activities[i]) {
                this.ensureLangsForItem(this.supplement.activities[i]);
                this.supplement.activities[i].langs[targetLang].text = text || "";
              }
            });
          }

          Toastify({
            text: `Campos traducidos con éxito al ${this.$t("components.langs." + targetLang + ".name")}.`,
            duration: 3000,
            gravity: "top",
            position: "right",
            style: {
              background: "linear-gradient(to right, #00b09b, #96c93d)",
            },
          }).showToast();
        } else {
          throw new Error("Estructura de respuesta inválida");
        }
      } catch (error) {
        console.error("Translation error:", error);
        const errMsg = error.response?.data?.msg || error.message || "Error durante la traducción.";
        Toastify({
          text: `Error al traducir: ${errMsg}`,
          duration: 5000,
          gravity: "top",
          position: "right",
          style: {
            background: "linear-gradient(to right, #ff5f6d, #ffc371)",
          },
        }).showToast();
      } finally {
        this.translating = false;
      }
    },
    async saveSupplement(event, force = false) {
      let allValid = true;
      //  Validación de sexos
      const validSex = this.validateSexDoses(force);
      if (!validSex) allValid = false;
      // exigir que todos los idiomas tengan texto

      const validDynamicFields = this.validateDynamicFields(
        this.supplement,
        this.allFields,
        this.langs, // ej: [{ key: 'es' }, { key: 'en' }]
        this.$t
      );

      if (!validDynamicFields) allValid = false;

      //  Validación de medicamentos
      const validMedicines = this.validateAllMedicineInteractions();

      // Validaciones listado de beneficios
      if (this.supplement.benefits.length === 0) {
        this.validations.benefits = "empty";
        allValid = false;
      } else if (this.supplement.benefits.length < 3) {
        this.validations.benefits = "min";
        allValid = false;
      } else {
        this.validations.benefits = false;
      }

      const duplicatedBenefits = this.hasDuplicateBenefits();

      if (duplicatedBenefits) {
        this.validations.benefitsDuplicate = true;
        allValid = false;
      } else {
        this.validations.benefitsDuplicate = false;
      }

      if (!validMedicines) allValid = false;
      // Validación de duplicados en medicinas
      const duplicatedMedicines = this.hasDuplicateMedicines();

      if (duplicatedMedicines) {
        this.validations.medicineDuplicate = true;
        allValid = false;
      } else {
        this.validations.medicineDuplicate = false;
      }
      //  Validación general del suplemento
      /* TODO: TEMPORAL - REMOVERLO HASTA QUE ED SUBA LOS SUPLEMENTOS. */
      const validSupplement = true; // this.validateSupplement()

      if (!validSupplement) allValid = false;

      // Si cualquier validación falla, abortamos
      if (false /*! allValid */) {
        // TODO: REMOVERLO TEMPORALMENTE
        return;
      }

      this.loading = true;
      // const payloadExample = this.getPayloadSupplement();
      // const payload = {}
      const [payload, editMode] = formatToSend(this.supplement, this.supplementCategories);

      // payload.status = this.supplement.status
      console.log("============= [saveSupplement] PAYLOAD FINAL =============");
      console.log("Modo edición:", editMode);
      console.log(" ID del suplemento:", this.supplement.id);
      console.log(" Payload completo a enviar:", payload);

      try {
        let responseSupplement;
        if (editMode && this.supplement.id) {
          console.log("viene a editar");
          responseSupplement = await NutrihubService.updateSupplement(this.supplement.id, payload);
        } else {
          console.log("viene a crear");
          responseSupplement = await NutrihubService.createSupplement(payload);
        }

        console.log(responseSupplement);
        const supplementID =
          responseSupplement?.id || responseSupplement?.data?.id || responseSupplement?.data?.data?.id;

        if (!supplementID) {
          console.error("El suplemento no se guardó correctamente: no se obtuvo un ID.", responseSupplement);
          this.showErrorToast(this.$t(`${this.viewRoot}.save_error`));
          return;
        }

        this.supplement.id = supplementID;

        // Wait for interactions to be created
        await this.createInteractions(supplementID);

        // Wait for interactions to be deleted
        await this.deleteInteractions(supplementID);

        // Clean up the local draft once the supplement is saved on the server
        await this.deleteLocalDraft();
        this.stopAutoSave();

        this.showToast(this.messages.savedSuccessId);
        this.goToList();
      } catch (e) {
        console.error("Error al guardar el suplemento", e);
        this.showErrorToast(this.$t(`${this.viewRoot}.save_error`));
      } finally {
        this.loading = false;
      }
    },
    goToTop: () => window.scrollTo({ top: 0, behavior: "smooth" }),
    async createInteractions(supplementID) {
      if (!supplementID) return;

      const promises = [];

      // 1) Supplements:start
      const interactionsSupplements = this.supplement.interactions.supplements
        .filter((s) => s.active === true && s.supplement_id)
        .flatMap((e) => {
          let s1 = Number(supplementID);
          let s2 = Number(e.supplement_id);

          if (s1 > s2) {
            [s1, s2] = [s2, s1];
          }

          return {
            id: e.id || null,
            supplement_id_1: s1,
            supplement_id_2: s2,
            description: e.description || "",
          };
        });

      if (interactionsSupplements.length > 0) {
        promises.push(SupplementService.saveInteractionSupplement(interactionsSupplements));
      }
      // 1) Supplements:end

      // 2) Diseases:start
      const interactionsDiseases = this.supplement.interactions.sicknesses
        .filter((s) => s.active === true)
        .map((s) => ({
          id: s.id || null,
          supplement_id: supplementID,
          disease_id: s.disease_id,
          description: s.description,
        }));

      if (interactionsDiseases.length > 0) {
        promises.push(DiseaseService.saveSupplementInteraction(interactionsDiseases));
      }
      // 2) Diseases:end

      // 3) Medicines:start
      const interactionsMedicines = (this.supplement.interactions.medicines || [])
        .filter((m) => m.medication_class_id && !m.deleted)
        .map((m) => {
          const sources = (m.sources || []).map((s) => ({
            id: s.id || null,
            source: s.source || "",
          }));

          const sourcesDeleted = (m.sources_deleted || []).filter((s) => String(s.trim()) !== "");

          return {
            // Interaction:start
            id: m.id || undefined,
            medication_class_id: m.medication_class_id,
            drug_id: m.generic || m.medication_class_drugs?.find((d) => d.active)?.drug_id || null,
            supplement_id: Number(supplementID),
            // Interaction:end

            // Detail of interaction:start
            interaction_medication_supplement_detail_id: m.interaction_medication_supplement_detail_id || null,
            level: m.level,
            action_mechanism: m.action_mechanism || "",
            description: m.description || "",
            // Detail of interaction:end

            // Sources of interaction:start
            sources: sources,
            sources_deleted: sourcesDeleted,
            // Sources of interaction:end
          };
        });
      if (interactionsMedicines.length) {
        promises.push(MedicationService.addMedicineSupplement(interactionsMedicines));
      }
      // Medicines:end

      await Promise.allSettled(promises);
    },
    async deleteInteractions(supplementID) {
      if (!supplementID) return;

      const promises = [];
      // 1) Supplements:start
      const interactionsSupplementsDeleted = this.supplement.interactions.supplements
        .filter((s) => !s.active && s.id)
        .map((s) => s.id);
      if (interactionsSupplementsDeleted.length) {
        promises.push(
          SupplementService.deleteListOfSupplementsPerOtherSupplement({
            supplementId: supplementID,
            ids: interactionsSupplementsDeleted,
          })
        );
      }
      // 1) Supplements:end

      // 2) Diseases:start
      const interactionsDiseasesDeleted = this.supplement.interactions.sicknesses
        .filter((s) => !s.active && s.id)
        .map((s) => s.id);
      if (interactionsDiseasesDeleted.length) {
        promises.push(
          DiseaseService.deleteListOfDiseasesPerSupplement({
            supplementId: supplementID,
            ids: interactionsDiseasesDeleted,
          })
        );
      }
      // 2) Diseases:end

      // 3) Medicines:start
      const interactionsMedicinesDeleted = (this.supplement.interactions.medicines || [])
        .filter((m) => m.deleted && m.id)
        .map((m) => m.id);

      if (interactionsMedicinesDeleted.length) {
        promises.push(
          MedicationService.deleteListOfMedicinesPerSupplement({
            supplementId: supplementID,
            ids: interactionsMedicinesDeleted,
          })
        );
      }
      // 3) Medicines:end

      await Promise.allSettled(promises);
    },

    confirmRemoveSupplement() {
      this.removeLoading = true;

      const styleInline = 'style="text-wrap: pretty;"';
      const message = `
        <h2 class="text-2xl mb-5 font-bold" ${styleInline}>
          ${this.$t("views.supplements.delete")}
        </h2>
        <p ${styleInline}>
          ${this.$t("views.supplements.delete")}
        </p>
      `;
      this.$refs.alertMessage.show(
        message,
        true, // botón confirmar
        true, // botón cancelar
        this.removeSupplement,
        true,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        this.cancelWarning
      );
    },
    cancelWarning() {
      this.removeLoading = false;
    },
    async removeSupplement() {
      const id = this.supplement.id;
      if (!id) {
        this.$refs.alertMessage.hide(); // use cancel warning
        return;
      }

      NutrihubService.remove(id)
        .then(() => {
          this.showToast(this.messages.removedSuccessId);
          this.$refs.alertMessage.hide();
          this.goToList();
        })
        .catch(() => {
          console.info("contact support: #NRS-001");
        })
        .finally(this.cancelWarning);
    },
    goToList() {
      this.$router.push({ path: "/supplement-list" });
    },
    /**
     * Show Toast
     */
    showToast(id) {
      Toastify({
        node: cash(`#${id}`).clone().removeClass("hidden")[0],
        duration: 3000,
        gravity: "top",
        position: "right",
        close: true,
      }).showToast();
    },
    showErrorToast(title, subtitle = "") {
      const subtitleHtml = subtitle ? `<div class="text-gray-600 mt-1">${subtitle}</div>` : "";
      Toastify({
        node: cash(
          `<div class="toastify-content flex"><XCircleIcon class="text-theme-6" /><div class="ml-4 mr-4"><div class="font-medium">${title}</div>${subtitleHtml}</div></div>`
        )[0],
        duration: 6000,
        gravity: "top",
        position: "right",
        close: true,
      }).showToast();
    },

    /**
     * * TEMPORARY SAVE (Local draft)
     * Saves/restores the supplement in IndexedDB without persisting to the server.
     */
    startAutoSave() {
      this.stopAutoSave();
      this.autoSaveInterval = setInterval(() => {
        // Avoid saving while the initial load or a server save is in progress
        if (!this.loading && !this.initialLoading) {
          this.saveTempSupplement(true);
        }
      }, this.AUTO_SAVE_INTERVAL_MS);
    },
    stopAutoSave() {
      if (this.autoSaveInterval) {
        clearInterval(this.autoSaveInterval);
        this.autoSaveInterval = null;
      }
    },
    async deleteLocalDraft() {
      const id = this.supplement.id || null;
      // Always clean the "new supplement" draft (-1) in case it was started as new
      await SupplementsLocalService.deleteTemp();
      if (id) {
        await SupplementsLocalService.deleteDraft(id);
      }
    },
    async saveTempSupplement(silent = false) {
      if (!silent) this.loading = true;

      const id = this.supplement.id || null;
      const supplement = JSON.stringify(this.supplement);
      const supplementCategories = JSON.stringify(this.supplementCategories);

      try {
        if (id) {
          await SupplementsLocalService.saveDraft(id, supplement, supplementCategories);
        } else {
          await SupplementsLocalService.saveTemp(supplement, supplementCategories);
        }
        if (!silent) this.showToast(this.messages.savedTempSuccessId);
      } catch (error) {
        console.error("Error al guardar temporalmente el suplemento:", error);
        if (!silent) {
          const htmlElement =
            '<div class="toastify-content flex"><XCircleIcon class="text-theme-6" /><div class="ml-4 mr-4"><div class="font-medium">Error al guardar temporalmente</div><div class="text-gray-600 mt-1">Inténtalo de nuevo.</div></div></div>';
          Toastify({
            node: cash(htmlElement)[0],
            duration: 3000,
            gravity: "top",
            position: "right",
            close: true,
          }).showToast();
        }
      } finally {
        if (!silent) this.loading = false;
      }
    },
    applyDraft(draft) {
      try {
        const supplement = JSON.parse(draft.supplement);
        const supplementCategories = JSON.parse(draft.supplementCategories || "[]");
        if (supplement) this.supplement = supplement;
        if (Array.isArray(supplementCategories)) this.supplementCategories = supplementCategories;
      } catch (e) {
        console.error("Error al restaurar el borrador del suplemento:", e);
      }
    },
    async checkForDraft() {
      const id = this.supplement.id || null;
      let draft;
      if (id) {
        draft = await SupplementsLocalService.getDraft(id);
      } else {
        draft = await SupplementsLocalService.getTemp();
      }
      if (!draft) return;

      const styleInline = 'style="text-wrap: pretty;"';
      const title = id
        ? this.$t(`${this.viewRoot}.message_draft_edit_1`)
        : this.$t(`${this.viewRoot}.message_draft_create_1`);
      const subtitle = id
        ? this.$t(`${this.viewRoot}.message_draft_edit_2`)
        : this.$t(`${this.viewRoot}.message_draft_create_2`);
      const message = `
        <h2 class="text-2xl mb-5 font-bold" ${styleInline}>${title}</h2>
        <p ${styleInline}>${subtitle}</p>
      `;

      let deletedData = true;
      this.$refs.alertContinueSupplement.show(
        message,
        true,
        true,
        () => {
          // Confirm callback
          deletedData = false;
          this.applyDraft(draft);
          this.$refs.alertContinueSupplement.hide();
        },
        true,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        () => {
          // Cancel callback
          if (deletedData) {
            if (id) {
              SupplementsLocalService.deleteDraft(id);
            } else {
              SupplementsLocalService.deleteTemp();
            }
          }
        }
      );
    },

    buildBenefitsPayload() {
      const benefitNameByValue = (v) => {
        const b = (this.allBenefits || []).find((x) => String(x.value) === String(v));
        return b ? b.name : v || "";
      };
      const problemNameByValue = (v) => {
        const p = (this.allProblems || []).find((x) => String(x.value ?? x.id) === String(v));
        return p ? p.name : v || "";
      };
      return (this.supplement.benefits || [])
        .filter((b) => b && (b.benefit || b.posology || b.problemIds?.length > 0))
        .map((b) => {
          const name = benefitNameByValue(b.benefit);
          const pos = b.posology ? (this.$t ? this.$t(`views.posology.${b.posology}`) : b.posology) : "";
          const probs = (b.problemIds || []).map((id) => problemNameByValue(id)).filter(Boolean);
          return [name, pos, ...probs].filter(Boolean).join(" | ");
        });
    },

    verifiedAccess() {
      const permissions = localStorage.backoffice_permissions ? JSON.parse(localStorage.backoffice_permissions) : [];

      const approvedPermission = permissions.find((p) => p.name == "SUPPLEMENT_ADMIN");
      if (approvedPermission) this.vueFillAprobed = true;
      else {
        this.vueFillAprobed = false;
      }
    },
    getLangsSupplement() {
      const langs = this.langs ?? this.$global.getLangs();
      const dataByLang = {
        name: "",
        chemicalName: "",
        familySupplement: "",
        description: "",
        comments: "",
      };
      const objectLangs = langs.map((l) => l.key).reduce((x, y) => ((x[y] = { ...dataByLang }), x), {});
      return objectLangs;
    },

    async loadAllSupplements() {
      try {
        const response = await NutrihubService.getAllSupplementsList();
        const currentInteractions = this.supplement.interactions.supplements || [];
        const currentSupplementId = this.supplement.id;

        const temporalSupplements = (response.data || [])
          .filter((item) => item.id !== currentSupplementId)
          .map((item) => {
            // Preserva el estado (active/description/id) de las interacciones ya cargadas
            const existing = currentInteractions.find((ci) => ci.supplement_id === item.id);
            if (existing) {
              return existing;
            }
            return {
              supplement_id: item.id,
              name: item.langs?.value || item.name || "",
              id: null, // For interaction id
              active: false, // For see interaction
              description: "", // For descripcion of interaction supplement
            };
          });

        this.supplement.interactions.supplements = temporalSupplements;
      } catch {
        this.supplement.interactions.supplements = [];
      }
    },
    async loadAllMedicines() {
      try {
        const response = await MedicationService.getAllFamilies();
        const raw = Array.isArray(response?.data) ? response.data : response || [];

        this.medicines = raw.map((cls) => {
          const medicationClassId = cls.medication_class_id ?? cls.id;
          const name = cls.name ?? "";

          const drugsRaw = Array.isArray(cls.medication_class_drugs) ? cls.medication_class_drugs : [];

          const medicationClassDrugs = drugsRaw
            .filter((d) => d && (d.drug || d.drug_id))
            .map((d) => ({
              drug_id: d.drug?.id ?? d.drug_id,
              name: d.drug?.name ?? d.name ?? "",
              action_mechanism: d.drug?.action_mechanism ?? d.action_mechanism ?? "",
              active: false,
            }));

          return { medication_class_id: medicationClassId, name, medication_class_drugs: medicationClassDrugs };
        });
      } catch {
        this.medicines = [];
      }
    },

    isMedicineComplete(medicine) {
      if (!medicine) return false;

      const hasClass = medicine.medication_class_id && medicine.medication_class_id !== "0";
      const hasGeneric = medicine.generic && medicine.generic !== "0";
      const hasLevel = medicine.level && medicine.level !== "0";
      const hasAction = medicine.action_mechanism && medicine.action_mechanism.trim() !== "";
      const hasDescription = medicine.description && medicine.description.trim() !== "";

      return hasClass && hasGeneric && hasLevel && hasAction && hasDescription;
    },
    updateGenericOptions(med, drugSelectedId = "") {
      const selectedClass = this.medicines.find((m) => m.medication_class_id === med.medication_class_id);

      // Delete action mechanism
      this.medicines.forEach((m) => {
        m.action_mechanism = "";
      });

      if (selectedClass) {
        med.medication_class_drugs = selectedClass.medication_class_drugs.map((d) => ({
          drug_id: d.drug_id,
          name: d.name,
          action_mechanism: d.action_mechanism,
          active: drugSelectedId.trim() !== "" ? drugSelectedId === d.drug_id : false,
        }));
      } else {
        med.medication_class_drugs = [];
      }

      med.generic = drugSelectedId; // reset genérico
      this.updateActionMechanism(med);
    },

    validateAllMedicineInteractions() {
      const medicines = this.supplement.interactions.medicines || [];
      let allValid = true;
      let hasAnyInteraction = false;

      const isFilled = (v) => v !== undefined && v !== null && String(v).trim() !== "" && v !== "0" && v !== "null";

      for (const medicine of medicines) {
        const hasClass = isFilled(medicine.medication_class_id);
        const hasGeneric = isFilled(medicine.generic);
        const hasLevel = isFilled(medicine.level);
        const hasAction = isFilled(medicine.action_mechanism);
        const hasDescription = isFilled(medicine.description);

        const touched = hasClass || hasGeneric || hasLevel || hasAction || hasDescription;

        if (touched) {
          hasAnyInteraction = true;
          if (!hasClass || !hasGeneric || !hasLevel || !hasAction || !hasDescription) {
            allValid = false;
          }
        }
      }

      if (!hasAnyInteraction) {
        this.validations.medicineFields = false;
        return true;
      }

      if (!allValid) {
        this.validations.medicineFields = "empty";
        return false;
      }

      this.validations.medicineFields = false;
      return true;
    },
    hasDuplicateMedicines() {
      const medicines = this.supplement.interactions.medicines || [];
      const combos = new Set();

      for (const med of medicines) {
        const fam = med.medication_class_id || "";
        const gen = med.generic || "";
        const lvl = med.level || "";
        if (fam && gen && lvl) {
          const key = `${fam}-${gen}-${lvl}`;
          if (combos.has(key)) {
            return true; // Duplicado
          }
          combos.add(key);
        }
      }
      return false;
    },

    loadCategories: async function (lang) {
      try {
        const res = await SupplementService.getCategories(lang);
        this.allCategories = Array.isArray(res) ? res : res?.data || [];
      } catch {
        this.allCategories = [];
      }
    },
    async loadAllDiseases() {
      try {
        const response = await DiseaseService.getAll();
        const fetchedDiseases = response.data ? response.data : response || [];
        const currentDiseases = this.supplement.interactions.sicknesses || [];
        const tempAllDiseases = fetchedDiseases.map((s) => {
          const existing = currentDiseases.find((cd) => cd.disease_id === s.id);
          if (existing) {
            return existing;
          }
          return {
            disease_id: s.id,
            name: s.name || "",
            id: null, // For interaction id
            active: false, // For see interaction
            description: "", // For descripcion of interaction disease
          };
        });
        this.supplement.interactions.sicknesses = tempAllDiseases;
      } catch {
        this.supplement.interactions.sicknesses = [];
      }
    },

    /**
     * Interactions current supplement
     */
    async getSupplementInteraction() {
      const id = this.supplement.id;

      if (!id) return;
      try {
        // Note: Only required field: "id", "supplement_id_1", "supplement_id_2", "description"
        const response = await SupplementService.getInteractionSupplement({ supplement_id: id });
        const tempInteractions = (response.data ?? [])
          .map((s) => ({
            id: s.id,
            supplement_id: s.supplement_id_1 === id ? s.supplement_id_2 : s.supplement_id_1,
            description: s.description || "",
          }))
          .filter((s) => s.supplement_id !== id);

        // Sort by supplement_id ascending
        tempInteractions.sort((a, b) => a.supplement_id - b.supplement_id);

        // Load active interactions
        for (let i = 0; i < this.supplement.interactions.supplements.length && tempInteractions.length; i++) {
          const s = this.supplement.interactions.supplements[i];

          const index = tempInteractions.findIndex((t) => t.supplement_id === s.supplement_id);
          if (index === -1) continue;

          // Deleted from tempInteractions
          const currentInteraction = tempInteractions.splice(index, 1);

          s.id = currentInteraction[0]?.id || null;
          s.active = true;
          s.description = currentInteraction[0]?.description || "";
        }
      } catch (error) {
        console.error("Error fetching interaction supplement:", error);
      }
    },
    async getDiseaseInteraction() {
      const id = this.supplement.id;

      if (!id) return;
      try {
        // Note: Only required field: "id", "disease_id", "description"
        const response = await DiseaseService.getSupplementInteraction(id);
        const tempInteractions = (response.data ?? []).map((s) => ({
          id: s.id,
          disease_id: s.disease_id,
          description: s.description || "",
        }));

        // Sort by disease_id ascending
        tempInteractions.sort((a, b) => a.disease_id - b.disease_id);

        // Load active interactions
        for (let i = 0; i < this.supplement.interactions.sicknesses.length && tempInteractions.length; i++) {
          const d = this.supplement.interactions.sicknesses[i];

          const index = tempInteractions.findIndex((t) => t.disease_id === d.disease_id);
          if (index === -1) continue;

          // Deleted from tempInteractions
          const currentInteraction = tempInteractions.splice(index, 1);

          d.id = currentInteraction[0]?.id || null;
          d.active = true;
          d.description = currentInteraction[0]?.description || "";
        }
      } catch (error) {
        console.error("Error fetching interaction diseases:", error);
      }
    },
    async getMedicineInteraction() {
      const id = this.supplement.id;

      if (!id) return;
      try {
        // Note: Only required field: ["id", "medication_class_id", "drug_id", "supplement_id", "interaction_medication_supplement_detail_id", "interaction_medication_supplement_detail"]
        // interaction_medication_supplement_detail: ["id", "action_mechanism", "level", "description", "interaction_medication_supplement_detail_sources"]
        // interaction_medication_supplement_detail_sources: ["id", "source"]
        const response = await MedicationService.getMedicineSupplement({ supplement_id: id });

        const tempInteractions = (response.data || []).map((m) => {
          const interactionalDetail = m.interaction_medication_supplement_detail || {};

          const allSourcesInteraction = interactionalDetail.interaction_medication_supplement_detail_sources || [];

          const sources = allSourcesInteraction.map((s) => ({
            id: s.id || null,
            source: s.source || "",
            edit: false,
            error: false,
          }));

          const newInteraction = {
            id: m.id || null, // interaction id
            medication_class_id: m.medication_class_id || "",
            generic: m.drug_id || "",
            deleted: false,

            // Interaction detail:start
            interaction_medication_supplement_detail_id: m.interaction_medication_supplement_detail_id || "",
            action_mechanism: interactionalDetail.action_mechanism || "",
            level: interactionalDetail.level || "",
            description: interactionalDetail.description || "",
            // Interaction detail:end

            medication_class_drugs: [], // load in updateGenericOptions
            source: "",
            name: "",
            sources: sources,
            sources_deleted: [],
          };

          this.updateGenericOptions(newInteraction, m.drug_id);

          return newInteraction;
        });

        if (tempInteractions.length < 1) {
          this.addMedicine();
          return;
        }

        this.supplement.interactions.medicines = tempInteractions;
      } catch (error) {
        console.error("Error fetching interaction diseases:", error);
      }
    },

    async loadAllBenefits() {
      try {
        const response = await NutrihubService.getSupplementBenefits();
        this.allBenefits = response.data ? response.data : response;
      } catch {
        this.allBenefits = [];
      }
    },

    async loadAllProblems() {
      try {
        const response = await NutrihubService.getSupplementProblems();
        this.allProblems = response.data ? response.data : response;
      } catch {
        this.allProblems = [];
      }
    },

    async loadAllPurposes() {
      try {
        const response = await NutrihubService.getPurposes(localStorage.lang);
        const list = Array.isArray(response) ? response : response?.data || [];
        // Normaliza a { id, name } para la sección "Sirve para"
        this.allUsedFor = list.map((p) => ({
          id: p.id,
          name: p.name || (p.langs?.find((l) => l.lang === this.global_lang)?.value ?? ""),
        }));
      } catch {
        this.allUsedFor = [];
      }
    },

    // TODO: remove function
    preparedLangs() {
      if (this.supplement.id && this.supplement.id != 0);

      // this.lang_inputs = this.langs.map(l => l.key).reduce((x, y) => (x[y] = { name: '', nameChamical: '', type: '', description: '', coments_glob: '', effects: [], effect: '', deficiencies: [], deficiency: '', excesses: [], excess: '', activities: [], activity: '' }, x), {})
      // this.lang_inputs[this.lang_key]['name'] = this.supplement['name']
      // const dataByLang = {
      //   nameTicket: "",
      // }
      // this.product.articles[0].langs = this.langs.map(l => l.key).reduce((x, y) => (x[y] = dataByLang, x), {})
      // if (this.product.articles.length < 1) this.addArticulo()
    },
    getPlaceholderText(val) {
      if (!val || !val.langs) return "";
      const priorityKeys = [];
      if (this.global_lang) {
        priorityKeys.push(this.global_lang);
      }
      priorityKeys.push("es");
      priorityKeys.push("en");

      for (const key of priorityKeys) {
        if (val.langs[key] && typeof val.langs[key].text === "string" && val.langs[key].text.trim() !== "") {
          return val.langs[key].text;
        }
      }

      for (const key in val.langs) {
        if (val.langs[key] && typeof val.langs[key].text === "string" && val.langs[key].text.trim() !== "") {
          return val.langs[key].text;
        }
      }

      return "";
    },
    // Normalizar cada item para que tenga todas las keys de idioma
    ensureLangsForItem(item) {
      // Asegura langs del sistema
      const langs = Array.isArray(this.langs) ? this.langs : [];
      // Permite formatos ['es','en'] o [{key:'es'}, {key:'en'}]
      const toKey = (l) => (typeof l === "string" ? l : l && l.key ? l.key : null);
      const langKeys = langs.map(toKey).filter(Boolean);

      if (!item.langs) item.langs = {};

      langKeys.forEach((key) => {
        if (!item.langs[key]) item.langs[key] = {};
        if (!item.langs[key].validation) {
          item.langs[key].validation = this.buildItemLangValidation
            ? this.buildItemLangValidation()
            : { active: false, text: "" };
        }
        if (typeof item.langs[key].text !== "string") item.langs[key].text = "";
        if (typeof item.langs[key].edit !== "boolean") item.langs[key].edit = false;
      });

      return item;
    },
    addField(type, inputFieldKey, event) {
      const currentInputText = this.supplement[inputFieldKey];
      const currentLangKey = this.lang_key;

      const shouldAdd =
        currentInputText &&
        currentInputText.trim() !== "" &&
        (event?.key === "Enter" || event?.pointerId || event?.type === "focusout" || !event);

      if (!shouldAdd) {
        if (event && currentInputText?.trim() === "") this.validations[type] = true;
        return;
      }

      if (!Array.isArray(this.supplement[type])) this.supplement[type] = [];

      const item = this.ensureLangsForItem({
        id: null,
        isNew: true,
        langs: {
          [currentLangKey]: {
            id: null,
            text: currentInputText,
            edit: false,
            error: false,
            validation: { text: "Falta completar", active: false },
          },
        },
      });

      this.supplement[type].push(item);
      this.supplement[inputFieldKey] = "";
      if (this.validations?.[type]) this.validations[type] = false;
    },

    editField(type, val, editMode) {
      if (!editMode && val.text === "") {
        val.error = true;
      } else {
        val.edit = editMode;
        val.error = false;
      }
    },

    deleteField(type, index) {
      if (!Array.isArray(this.supplement[type])) return;
      this.supplement[type].splice(index, 1);
    },

    // Validate items of the Field effects, deficiencies, excesses and activities with text message langs
    validateDynamicFields(model, allFields, langs = [], t = (k) => k) {
      let ok = true;
      const toKey = (l) => (typeof l === "string" ? l : l && l.key ? l.key : null);
      const langKeys = (this.langs || []).map(toKey).filter(Boolean);

      this.allFields.forEach(({ type }) => {
        const list = Array.isArray(this.supplement[type]) ? this.supplement[type] : [];
        list.forEach((item) => {
          this.ensureLangsForItem(item); // asegura estructura
          langKeys.forEach((key) => {
            const txt = (item.langs[key]?.text || "").trim();
            if (!txt) {
              ok = false;
              item.langs[key].validation.active = true;
              item.langs[key].validation.text = this.$t("views.supplements.validations.required_lang", {
                lang: this.$t(`components.langs.${key}.name`),
              });
            } else {
              item.langs[key].validation.active = false;
              item.langs[key].validation.text = "";
            }
          });
        });
      });

      return ok;
    },

    // Inicializa el contenedor de error por idioma en cada ítem
    buildItemLangValidation() {
      return { active: false, text: "" };
    },

    getInitialValidations() {
      return {
        categories: false, //*
        usedFor: false,
        name: false, //*
        chemicalName: false, //*
        familySupplement: false, //*
        description: false, //*
        ec: false,
        bd: false,
        rc: false,
        est: false,
        benefits: false, //*
        problemIds: false,
        range: false,
        doses: false, //*
        effects: false,
        deficiencies: false,
        excesses: false,
        activities: false,
        eastSources: false, //
        westSources: false,
        pubmedUrl: false, //*
        nihUrl: false, //*
        cochraneUrl: false, //*
        medlineUrl: false, //*
        mayoUrl: false, //*
        clinicalUrl: false, //*
        newenglandUrl: false, //*
        lancetUrl: false, //*
        cnkiUrl: false, //*
        koreanmedUrl: false, //*
        jstageUrl: false, //*
        tkdlUrl: false, //*
        wanfangUrl: false, //*
        ktkpUrl: false, //*
        //   validaciones de descripción
        pubmedDescription: false,
        nihDescription: false,
        cochraneDescription: false,
        medlineDescription: false,
        mayoDescription: false,
        clinicalDescription: false,
        newenglandDescription: false,
        lancetDescription: false,
        cnkiDescription: false,
        koreanmedDescription: false,
        jstageDescription: false,
        tkdlDescription: false,
        wanfangDescription: false,
        ktkpDescription: false,
        status: false,
        medicineFields: false,
        medicineDuplicate: false,
        comments: false,
        benefitsDuplicate: false,
      };
    },

    validateSupplement() {
      this.validations = this.getInitialValidations();
      // Reinicia validaciones de idiomas
      this.langValidations = {};
      this.langs.forEach(({ key }) => {
        this.langValidations[key] = false;
      });

      for (const l of this.langs) {
        const lang = l.key;
        const data = this.supplement.langs[lang];
        let hasError = false;

        // Nombre comercial
        if (!data.name?.trim() || countChars(data.name) < 3 || countChars(data.name) > 35) {
          hasError = true;
        }

        // Nombre químico
        if (!data.chemicalName?.trim() || countChars(data.chemicalName) < 3 || countChars(data.chemicalName) > 35) {
          hasError = true;
        }

        // Tipo / variedad
        if (
          !data.familySupplement?.trim() ||
          countChars(data.familySupplement) < 3 ||
          countChars(data.familySupplement) > 35
        ) {
          hasError = true;
        }

        // Descripción
        if (!data.description?.trim()) {
          hasError = true;
        }

        // Categorías
        if (this.supplementCategories.length === 0) {
          this.validations.categories = "empty";
          hasError = true;
        }

        // Sirve para
        if (this.supplement.usedFor.length === 0) {
          this.validations.usedFor = "empty";
          hasError = true;
        }
        // Validación: al menos 3 fuentes de Occidente y 3 de Oriente
        const eastCount = (this.supplement.scienceSources.east || []).filter(
          (s) => s.url && s.url.trim() !== ""
        ).length;
        const westCount = (this.supplement.scienceSources.west || []).filter(
          (s) => s.url && s.url.trim() !== ""
        ).length;

        if (eastCount < 3) {
          this.validations.eastSources = "min";
          hasError = true;
        } else {
          this.validations.eastSources = false;
        }

        if (westCount < 3) {
          this.validations.westSources = "min";
          hasError = true;
        } else {
          this.validations.westSources = false;
        }

        // Validar URLs y descripciones de las fuentes de Occidente
        (this.supplement.scienceSources.east || []).forEach((source) => {
          source.urlError = false;
          source.descriptionError = false;
          if (source.url && source.url.trim() !== "") {
            const { valid, reason } = this.isURLValid(source.url);
            if (!valid) {
              source.urlError = reason;
              hasError = true;
            }
            if (!source.description || !source.description.trim()) {
              source.descriptionError = true;
              hasError = true;
            }
          }
        });

        // Validar URLs y descripciones de las fuentes de Oriente
        (this.supplement.scienceSources.west || []).forEach((source) => {
          source.urlError = false;
          source.descriptionError = false;
          if (source.url && source.url.trim() !== "") {
            const { valid, reason } = this.isURLValid(source.url);
            if (!valid) {
              source.urlError = reason;
              hasError = true;
            }
            if (!source.description || !source.description.trim()) {
              source.descriptionError = true;
              hasError = true;
            }
          }
        });

        // Validación: al menos tres beneficios completos
        const validBenefits = (this.supplement.benefits || []).filter((b) => {
          const idOrBenefit = b.id || b.benefit;
          const hasBenefit = idOrBenefit && idOrBenefit !== "0";
          const hasPosology = !!b.posology;
          const hasProblem = b.problemIds?.length > 0;
          return hasBenefit && hasPosology && hasProblem;
        });

        // Menos de 3 o incompletos
        if (validBenefits.length < 3) {
          this.validations.benefits = "min";
        } else {
          this.validations.benefits = false;
        }

        //  validación: beneficios duplicados (Beneficio + Momento + Problemática)
        const hasDup = this.hasDuplicateBenefits();
        if (hasDup) {
          this.validations.benefitsDuplicate = true;
        } else {
          this.validations.benefitsDuplicate = false;
        }
        // Validación: al menos una dosis completa
        if (
          !this.supplement.doses.length ||
          this.supplement.doses.some((d) => {
            // Campos básicos requeridos
            const basicsOk = d.biologicalSex && d.ages.length > 0 && d.modality;

            if (!basicsOk) return true;

            if (d.modality === "SPECIFIC") {
              return !(Array.isArray(d.specificValues) && d.specificValues.every((v) => v !== null && v !== ""));
            }

            if (d.modality === "RANGE") {
              return !(
                Array.isArray(d.rangeValues) &&
                d.rangeValues.every((r) => r.min !== null && r.min !== "" && r.max !== null && r.max !== "")
              );
            }

            return true;
          })
        ) {
          this.validations.doses = "empty";
          hasError = true;
        } else {
          this.validations.doses = false;
        }
        /// Validación de comentarios entre idiomas
        const comments = this.langs.map(({ key }) => (this.supplement.langs[key].comments || "").trim());
        const someFilled = comments.some((c) => c !== "");
        const allFilled = comments.every((c) => c !== "");

        if (someFilled && !allFilled && !data.comments?.trim()) {
          this.validations[`comments_${lang}`] = true;
          hasError = true;
        } else {
          this.validations[`comments_${lang}`] = false;
        }
        this.langValidations[lang] = hasError;
      }
      //  Validación: Interacciones de suplementos con descripción vacía
      const invalidSupplementInteractions = this.supplement.interactions.supplements.filter(
        (s) => s.active && (!s.description || !s.description.trim())
      );
      if (invalidSupplementInteractions.length > 0) {
        this.validations.supplementInteractions = "missing_description";
      } else {
        this.validations.supplementInteractions = false;
      }

      //  Validación: Interacciones de enfermedades con descripción vacía
      const invalidDiseaseInteractions = this.supplement.interactions.sicknesses.filter(
        (d) => d.active && (!d.description || !d.description.trim())
      );
      if (invalidDiseaseInteractions.length > 0) {
        this.validations.diseaseInteractions = "missing_description";
      } else {
        this.validations.diseaseInteractions = false;
      }

      return (
        !Object.values(this.validations).some((v) => v !== false) &&
        !Object.values(this.langValidations).some((v) => v === true)
      );
    },
    isURLValid(url) {
      if (!url) return { valid: true };

      // Validar longitud
      if (url.length > 2000) {
        return { valid: false, reason: "too_long" };
      }

      // Validar formato
      const pattern = new RegExp(
        "^(https?:\\/\\/)?" +
          "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" +
          "((\\d{1,3}\\.){3}\\d{1,3}))" +
          "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" +
          "(\\?[;&a-z\\d%_.~+=-]*)?" +
          "(\\#[-a-z\\d_]*)?$",
        "i"
      );

      if (!pattern.test(url)) {
        return { valid: false, reason: "invalid_format" };
      }

      return { valid: true };
    },

    goSource(url) {
      window.open(url, "_blank");
    },

    /**
     * * lANGS CONFIGs
     */
    changeLang(l) {
      this.activeLang = l;
      const k = l.replace("lang__", "");
      this.lang_key = k;

      ["effects", "deficiencies", "excesses", "activities"].forEach((t) => {
        if (Array.isArray(this.supplement[t])) {
          this.supplement[t] = this.supplement[t].map(this.ensureLangsForItem);
        }
      });
    },

    addInteraction(section, type) {
      if (type === "supplement") {
        this.supplement.interactions[section].map((s) => {
          if (s.supplement_id === parseInt(this.supplement.interactions[type])) {
            s.active = true;
          }
          return s;
        });
      }

      if (type === "sickness") {
        this.supplement.interactions[section].map((s) => {
          if (s.disease_id === this.supplement.interactions[type]) {
            s.active = true;
          }
          return s;
        });
      }

      this.supplement.interactions[type] = "";
    },
    removeInteraction(item, type, key = "id") {
      this.supplement.interactions[type].map((s) => {
        if (s[key] === item[key]) s.active = false;
        return s;
      });
    },
    addMedicine() {
      // Solo agrega un bloque nuevo si no hay uno vacío
      const hasEmpty = (this.supplement.interactions.medicines || []).some((m) => !m.medication_class_id);
      if (!hasEmpty) {
        this.supplement.interactions.medicines.push({
          id: "",
          interaction_medication_supplement_detail_id: null,
          medication_class_id: "",
          name: "",
          level: "",
          deleted: false,
          action_mechanism: "",
          description: "",
          generic: "",
          medication_class_drugs: [],
          source: "",
          sources: [],
          sources_deleted: [],
        });
      }
    },

    updateStatusMedicine(m, value = true) {
      m.deleted = value;
    },

    addMedicineItem(medicine) {
      const chosenDrugId = medicine.generic;
      if (!chosenDrugId) return;

      medicine.medication_class_drugs.forEach((d) => {
        d.active = String(d.drug_id) === String(chosenDrugId);
      });
      this.updateActionMechanism(medicine);
    },

    removeMedicineItem(medicine, drug) {
      drug.active = false;
    },
    updateActionMechanism(medicine) {
      const selectedDrug = medicine.medication_class_drugs.find((d) => String(d.drug_id) === String(medicine.generic));
      medicine.action_mechanism = selectedDrug ? selectedDrug.action_mechanism : "";
    },
    openFamilyQuickCreateModal(medicineKey) {
      this.currentMedicineRowKey = medicineKey;
      this.$refs.familyQuickCreateModal.show();
    },
    async handleFamilyCreated({ id }) {
      await this.loadAllMedicines();
      const medicine = this.supplement.interactions.medicines[this.currentMedicineRowKey];
      if (medicine) {
        medicine.medication_class_id = id;
        this.updateGenericOptions(medicine, "");
      }
    },
    openDrugQuickCreateModal(medicine, medicineKey) {
      this.currentMedicineRowKey = medicineKey;
      this.activeFamilyId = medicine.medication_class_id;
      this.$nextTick(() => {
        this.$refs.drugQuickCreateModal.show();
      });
    },
    async handleDrugCreated({ id }) {
      await this.loadAllMedicines();
      const medicine = this.supplement.interactions.medicines[this.currentMedicineRowKey];
      if (medicine) {
        this.updateGenericOptions(medicine, id);
      }
    },
    medicineSourceAdd: function (event, m) {
      if (m.source != "" && (event.key == "Enter" || event.pointerId || event.type == "focusout")) {
        if (this.isURLValid(m.source)) {
          m.sources.push({ id: null, source: m.source, edit: false, error: false });
          m.source = "";
        }
      }
    },
    medicineSourceEdit: function (val) {
      if (this.isURLValid(val.source)) {
        val.edit = false;
      } else {
        val.error = true;
      }
    },
    medicineSourceDelete: function (val, m) {
      var i = m.sources.findIndex(function (s) {
        return s == val;
      });

      var s = m.sources.splice(i, 1);
      if (s.length > 0 && s[0].id) {
        m.sources_deleted.push(s[0].id);
      }
    },
    isFormComplete() {
      return this.supplement.benefits.every(
        (benefit) => benefit.id && benefit.posology && benefit.problemIds?.length > 0
      );
    },
    openQuickCreateModal(index) {
      this.$refs.benefitQuickCreateModal.show(index);
    },
    async handleBenefitCreated({ benefit, index }) {
      this.allBenefits = [];
      await this.loadAllBenefits();
      if (index !== null && this.supplement.benefits[index]) {
        this.supplement.benefits[index].id = String(benefit.id);
        this.supplement.benefits[index].benefit = String(benefit.id);
      }
    },
    openProblemQuickCreateModal(index) {
      this.$refs.problemQuickCreateModal.show(index);
    },
    async handleProblemCreated({ problem, index }) {
      this.allProblems = [];
      await this.loadAllProblems();
      if (index !== null && this.supplement.benefits[index]) {
        if (!Array.isArray(this.supplement.benefits[index].problemIds)) {
          this.supplement.benefits[index].problemIds = [];
        }
        this.supplement.benefits[index].problemIds.push(String(problem.id));
      }
    },
    openPurposeQuickCreateModal() {
      this.$refs.purposeQuickCreateModal.show();
    },
    async handlePurposeCreated({ purpose }) {
      this.allUsedFor = [];
      await this.loadAllPurposes();

      const id = String(purpose?.id);
      if (!this.supplement.usedFor.includes(id)) {
        this.supplement.usedFor = [...this.supplement.usedFor, id];
      }
    },
    openDiseaseQuickCreateModal() {
      this.$refs.diseaseQuickCreateModal.show();
    },
    async handleDiseaseCreated(disease) {
      await this.loadAllDiseases();
      const newSickness = (this.supplement.interactions.sicknesses || []).find((s) => s.disease_id === disease.id);

      if (newSickness) {
        newSickness.active = true;
      }
    },
    openSupplementQuickCreateModal() {
      this.$refs.supplementQuickCreateModal.show();
    },
    async handleSupplementQuickCreated({ supplement }) {
      await this.loadAllSupplements();
      const newInteraction = (this.supplement.interactions.supplements || []).find(
        (s) => s.supplement_id === supplement.id
      );

      if (newInteraction) {
        newInteraction.active = true;
      }
    },
    goToSupplement(id) {
      const route = this.$router.resolve({ path: "/supplement-edit", query: { id } });
      window.open(route.href, "_blank");
    },
    goToDisease(id) {
      const route = this.$router.resolve({ path: "/disease-edit", query: { id } });
      window.open(route.href, "_blank");
    },
    openPlatformQuickCreateModal(region) {
      this.$refs.platformQuickCreateModal.show(region);
    },
    async handlePlatformCreated({ id, name, region_of_origin: regionOfOrigin }) {
      await this.loadAllPlatforms();
      if (id) {
        if (regionOfOrigin === "WESTERN") {
          this.selectedWesternPlatform = id;
        } else if (regionOfOrigin === "EASTERN") {
          this.selectedEasternPlatform = id;
        }
      }
    },
    addBenefit() {
      this.supplement.benefits.push({
        id: null,
        benefit: "",
        posology: "",
        problemIds: [],
        score: {
          ec: 0,
          bd: 0,
          rc: 0,
          est: 0,
          totalScore: 0,
        },
      });
    },
    totalScore(benefit) {
      benefit.score.ec = this.validateMinAndMax(benefit.score.ec);
      benefit.score.bd = this.validateMinAndMax(benefit.score.bd);
      benefit.score.rc = this.validateMinAndMax(benefit.score.rc);
      benefit.score.est = this.validateMinAndMax(benefit.score.est);

      const ec = benefit.score.ec;
      const bd = benefit.score.bd;
      const rc = benefit.score.rc;
      const est = benefit.score.est;

      benefit.score.totalScore = Math.round((ec * 0.4 + bd * 0.3 + rc * 0.2 + est * 0.1) * 10);
    },
    validateMinAndMax(value) {
      const min = 0;
      const max = 10;

      const newValue = parseInt(value);
      if (isNaN(newValue)) {
        return 0;
      }

      if (newValue < min) {
        return min;
      }

      if (newValue > max) {
        return max;
      }

      return newValue;
    },
    removeBenefit(index) {
      if (this.supplement.benefits.length > 1) {
        this.supplement.benefits.splice(index, 1);
      }
    },
    validateFields() {
      return this.supplement.doses.every((d) => {
        const basicsOk = d.biologicalSex && d.ages.length > 0 && d.modality;
        if (!basicsOk) return false;

        if (d.modality === "SPECIFIC") {
          const [opt, ref, upp] = d.specificValues || [];

          // Óptimo y referencia obligatorios
          if (opt === null || opt === "" || ref === null || ref === "") {
            return false;
          }

          // Límite superior recomendado opcional
          if (upp !== null && upp !== "") {
            const uppVal = Number(upp);
            if (isNaN(uppVal) || uppVal < 0) return false;
            if (!isNaN(opt) && uppVal <= Number(opt)) return false;
          }

          return true;
        }

        if (d.modality === "RANGE") {
          const [opt, ref, upp] = d.rangeValues || [];

          // Óptimo y referencia obligatorios
          if (
            !opt ||
            opt.min === null ||
            opt.min === "" ||
            opt.max === null ||
            opt.max === "" ||
            !ref ||
            ref.min === null ||
            ref.min === "" ||
            ref.max === null ||
            ref.max === ""
          ) {
            return false;
          }

          const optMax = Number(opt.max);

          // Límite superior recomendado: puede ser null, pero si existe debe ser >=0 y > opt.max
          if (upp) {
            const uppMin = upp.min !== null && upp.min !== "" ? Number(upp.min) : null;
            const uppMax = upp.max !== null && upp.max !== "" ? Number(upp.max) : null;

            // Caso: uno lleno y el otro vacío → inválido
            if ((uppMin !== null && uppMax === null) || (uppMax !== null && uppMin === null)) {
              return false;
            }

            // Si existen, deben ser >= 0
            if ((uppMin !== null && uppMin < 0) || (uppMax !== null && uppMax < 0)) {
              return false;
            }

            // Validar que upp.min > opt.max
            if (uppMin !== null && uppMin <= optMax) {
              return false;
            }

            // Validar que upp.max >= upp.min
            if (uppMin !== null && uppMax !== null && uppMax < uppMin) {
              return false;
            }
          }

          return true;
        }

        return false;
      });
    },

    addDose() {
      this.supplement.doses.push({
        id: "",
        biologicalSex: "",
        ages: [],
        modality: "SPECIFIC",
        unit: "",
        specificValues: [null, null, null],
        rangeValues: [
          { min: null, max: null },
          { min: null, max: null },
          { min: null, max: null },
        ],
      });
    },
    removeDose(index) {
      if (this.supplement.doses.length > 1) {
        this.supplement.doses.splice(index, 1);
      }
    },
    async loadAllPlatforms() {
      try {
        const response = await ScienceSourceService.getAll();
        this.allPlatforms = Array.isArray(response) ? response : response?.data || [];
      } catch {
        this.allPlatforms = [];
      }
    },
    addWesternSource(platformId) {
      if (!platformId) return;

      const platform = this.allPlatforms.find((p) => p.id == platformId);
      if (platform) {
        this.supplement.scienceSources.east.unshift({
          id: null,
          platformId: platform.id,
          platformName: platform.name,
          url: "",
          platformReferenceId: "",
          doi: "",
          description: "",
          urlError: false,
          descriptionError: false,
        });
      }
      this.selectedWesternPlatform = "";
    },
    addEasternSource(platformId) {
      if (!platformId) return;

      const platform = this.allPlatforms.find((p) => p.id == platformId);
      if (platform) {
        this.supplement.scienceSources.west.unshift({
          id: null,
          platformId: platform.id,
          platformName: platform.name,
          url: "",
          platformReferenceId: "",
          doi: "",
          description: "",
          urlError: false,
          descriptionError: false,
        });
      }
      this.selectedEasternPlatform = "";
    },
    removeWesternSource(index) {
      this.supplement.scienceSources.east.splice(index, 1);
    },
    removeEasternSource(index) {
      this.supplement.scienceSources.west.splice(index, 1);
    },
    validateURLs() {
      this.supplement.scienceSources.east.forEach((source) => {
        source.urlError = false;
        if (source.url && source.url.trim() !== "") {
          const { valid, reason } = this.isURLValid(source.url);
          if (!valid) {
            source.urlError = reason;
          }
        }
      });
      this.supplement.scienceSources.west.forEach((source) => {
        source.urlError = false;
        if (source.url && source.url.trim() !== "") {
          const { valid, reason } = this.isURLValid(source.url);
          if (!valid) {
            source.urlError = reason;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dark .accordion .accordion-item .accordion-header .accordion-button:not(.collapsed) {
  --tw-text-opacity: 1;
  color: #fff;
}

.mt-3 {
  color: #fff;
}

.modal-body .recomendacion-headline {
  display: none;
}

.modal-body ul:not(ul:first-of-type) {
  margin-left: 30px;
  margin-top: 15px;
  margin-bottom: 15px;
}

.modal-body li {
  margin-top: 10px;
  margin-bottom: 10px;
}

.max-w-label {
  max-width: 90%;
}

.text-sm-14 {
  font-size: 0.875rem;
}

.btn-source-icon {
  width: 1rem;
}

.btn-source-icon.w-6 {
  width: 1.5rem;
}

.w-50 {
  width: 50%;
}

.my-custom-input {
  display: none !important;
}

.transparent {
  color: transparent;
}

.benefits_item:last-child .remove-item {
  visibility: hidden;
}

.benefits_item:nth-child(2) {
  margin-top: 0px;
}

.form-check-input {
  min-width: 16px;
  min-height: 16px;
}

.field__medicine {
  transition: all 0.3s ease;

  &.medicine__deleted {
    opacity: 0.5 !important;

    .deleted__field__hidden {
      height: 0;
      opacity: 0;
      margin: 0;
      padding: 0;
      overflow: hidden;
    }

    .deleted__field__disabled {
      pointer-events: none;
    }
  }
}

.tooltip {
  position: relative;
  display: inline-block;

  .tooltip__text {
    visibility: hidden;
    opacity: 0;
    width: max-content;
    background-color: #333;
    color: #fff;
    text-align: center;
    border-radius: 4px;
    padding: 6px 8px;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    left: 50%;
    transform: translateX(-50%);
    transition: opacity 0.3s;

    /* triángulo */
    &::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: #333 transparent transparent transparent;
    }
  }

  &:hover .tooltip__text {
    visibility: visible;
    opacity: 1;
  }
}
</style>

<style>
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  opacity: 0.2 !important;
  /* Firefox */
}
</style>
